import { IPaginationResponse } from '../../../../core';
import { ISpecializedRoleCreateResponse, ISpecializedRoleResponse } from '../dtos';

const specilziedRoles: IPaginationResponse<ISpecializedRoleResponse> = {
  items: [
    {
      systemRole: {
        englishName: 'Administrator',
        id: '15ba0880-2438-4f30-8d65-17bd3374bec1'
      },
      permissions: [
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Create',
          id: '4d51562a-9365-455c-94a1-be412dda14e4'
        },
        {
          englishName: 'PharmacyManagement.Drugs.Update',
          id: '0edd86a8-9ffb-46ab-a171-dca191192a57'
        },
        {
          englishName: 'PatientManagement.Symptoms.AddDrug',
          id: 'da300683-8cfb-439b-afe8-2a21049710d0'
        },
        {
          englishName: 'PharmacyManagement.Drugs.ReadAll',
          id: 'ae0c99f8-a596-453c-a1fc-be9274226805'
        },
        {
          englishName: 'PatientManagement.Symptoms.ReadAll',
          id: '6b9b7295-6f5e-4e93-8f28-71991afbb90e'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.Activate',
          id: '815fc778-a4f4-4f5f-b1f3-2f070bd61c4a'
        },
        {
          englishName: 'PatientManagement.Diseases.Create',
          id: 'e210c609-467b-492b-9632-37c6cdd9b125'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.Activate',
          id: '617764db-be81-4bd3-b6c8-f9bbccdef5c3'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.Activate',
          id: '0f90b32a-c44d-4d1c-82b3-83030dfa8290'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.Create',
          id: '716f8191-c53a-4793-8666-0e9e1fecbdf9'
        },
        {
          englishName: 'PatientManagement.XRays.DeActivate',
          id: '133c73ca-5c71-465c-b047-465577c414f3'
        },
        {
          englishName: 'SupplierManagement.Hospitals.Activate',
          id: 'd096403c-5cbc-4d62-9f4c-cd1c35441316'
        },
        {
          englishName: 'PatientManagement.Surgeries.Import',
          id: '8bb968c1-c29e-40ea-8c08-9c870697b033'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.Update',
          id: 'dd961ebc-5ac7-41f3-b045-cbd531ec4482'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.Read',
          id: '403f0c5b-e4bd-4b73-a000-f4c55527929e'
        },
        {
          englishName: 'PatientManagement.Surgeries.ReadAll',
          id: 'a41c9af2-eb63-4e9a-a357-ca9c0db6852c'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.Update',
          id: 'd95f964d-6979-40bd-89a5-78d4d13582f1'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.Create',
          id: '20438ba8-0793-4da1-8928-5ca6eac10484'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.Read',
          id: '187005d5-9779-49ce-9607-9daa49245822'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.ReadAll',
          id: 'f406b7a6-a766-42d4-bc2d-f90d2b3b30a4'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.Update',
          id: '7ccf621f-7111-4f73-b336-94e76f20db00'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.ReadAll',
          id: '1c1ca879-9f80-4feb-bc5e-d098e714e240'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.Activate',
          id: 'c981bc27-bf86-49a5-9fba-25a614c72fa4'
        },
        {
          englishName: 'SupplierManagement.Doctors.DeActivate',
          id: 'c53f1421-bfd3-4378-959b-9c29e8ad9fae'
        },
        {
          englishName: 'PatientManagement.XRays.ReadAll',
          id: 'bef27c7a-deed-492b-85eb-31eadeccd60d'
        },
        {
          englishName: 'PatientManagement.Allergies.ReadAll',
          id: '7d46fca5-bd62-43c7-b053-57da68c7ace5'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.ReadAll',
          id: '6056fc19-8812-4701-92d7-b424da47db82'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.ReadAll',
          id: '107e4459-fce2-4368-a23f-de551285d68c'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.Activate',
          id: 'f522684f-8981-43ba-975d-9695ebbce5ee'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.Update',
          id: '02112746-8242-4252-b056-4c2d0697ad6e'
        },
        {
          englishName: 'PatientManagement.XRays.Create',
          id: '5195d4e6-a040-425c-b970-ae64c75bf13b'
        },
        {
          englishName: 'PatientManagement.Surgeries.Update',
          id: '4bb02be1-b34b-4cdd-8370-627b9f4ad3cd'
        },
        {
          englishName: 'PatientManagement.XRays.Update',
          id: '4a5103c4-6e5e-4c22-bc4b-d3d377a02a5f'
        },
        {
          englishName: 'SupplierManagement.Hospitals.Read',
          id: 'eb368ee7-2dee-41a3-8cef-3995d9f577e7'
        },
        {
          englishName: 'UtilityManagement.Attachments.Read',
          id: '860699e1-5f45-4ca9-9674-32b742b29b38'
        },
        {
          englishName: 'SupplierManagement.Doctors.Activate',
          id: 'cec1b0fd-b8ca-4e33-8d14-9a3ec34dd80b'
        },
        {
          englishName: 'PharmacyManagement.Drugs.Activate',
          id: '6ca47d03-2bf9-4821-aed0-1858eb47bc8f'
        },
        {
          englishName: 'PatientManagement.Surgeries.Read',
          id: '843c8c89-4965-4778-b88d-b3ae698e308a'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.ReadAll',
          id: 'bd6033b1-a99b-4263-b553-98c1872802b1'
        },
        {
          englishName: 'PatientManagement.Allergies.Import',
          id: '8694a366-5932-4fc7-9446-b2d9eaf429bd'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.Activate',
          id: 'cb828ba5-1da1-4e75-83fe-26aa69e800e6'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.DeActivate',
          id: 'dcdaed09-5a2e-4743-9e71-4a5d2dd2dfeb'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.Create',
          id: '9617bac1-e20a-4619-b5f5-a3c10270d0fa'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.Update',
          id: '458b5499-3ff3-4891-abd0-6b5c2de1f0fd'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.DeActivate',
          id: '88c945a1-412d-47df-9762-6eea6dd66494'
        },
        {
          englishName: 'PatientManagement.XRays.Read',
          id: '77ff5753-3c54-4b8a-94e3-286d2ac9ebac'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.Create',
          id: 'c2fe5690-07b7-4ff9-b867-d372a4c3a025'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.DeActivate',
          id: '489da94a-d917-494c-8663-b3809fb971ee'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.Read',
          id: 'df441d01-d694-4012-be80-61e7b7b734b7'
        },
        {
          englishName: 'PatientManagement.Symptoms.Create',
          id: '9a3bad69-5a98-4a9a-b5d9-10f1adf4564a'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.Create',
          id: 'cc5bd4e5-7bb4-4ae6-9672-0f5c560ab7db'
        },
        {
          englishName: 'PatientManagement.Diseases.Activate',
          id: '49557d1a-20c1-4f8e-a37e-84bc088161a0'
        },
        {
          englishName: 'UtilityManagement.Attachments.Create',
          id: '5521ed9b-cd88-46c8-97fe-9fb6c17e6a53'
        },
        {
          englishName: 'PatientManagement.Addictions.Update',
          id: '02e56ebf-1fe6-4561-86a9-4e338c9b10b5'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.Create',
          id: 'cd022a9b-ec17-40a6-8f10-49c0a1b45f9a'
        },
        {
          englishName: 'PatientManagement.Symptoms.DeActivate',
          id: 'b62235bb-24b0-4f25-adc3-f29cfe7fbb08'
        },
        {
          englishName: 'PatientManagement.Surgeries.Create',
          id: '4a192605-0372-4d15-81c0-16b98118fc70'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.Create',
          id: '882ef2af-56f1-4c0f-b52e-cfbfa2139a4b'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.DeActivate',
          id: '1f35334d-d760-4116-a193-fcf2b4dbc806'
        },
        {
          englishName: 'SupplierManagement.Doctors.Update',
          id: 'a4285f66-93a2-459a-9ed2-6fb359d4da53'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.Read',
          id: 'c4222ad7-8d31-4c6a-ab30-849263a93a1e'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.ReadAll',
          id: '18ff90f3-79dc-4657-80f6-5d01a339d44e'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.DeActivate',
          id: '1abbd14f-64eb-45f3-8ec7-6f84cf9eeb3e'
        },
        {
          englishName: 'SupplierManagement.Doctors.Create',
          id: '43113c9f-0af7-405b-bdc2-d44bf4282b32'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.ReadAll',
          id: '2b002274-82a0-4657-994a-9ec3fa50413c'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.Create',
          id: 'a23593d5-79db-440e-a86c-691da112bcc9'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.ReadAll',
          id: 'c2c39be1-db3b-4970-9f3f-ab8bdeabebf1'
        },
        {
          englishName: 'SupplierManagement.Doctors.ReadAll',
          id: '0101e959-49a0-4b49-8daa-033a8f8bc9db'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Read',
          id: '84f5f633-f3a9-458a-9d4a-07c9853596e4'
        },
        {
          englishName: 'PatientManagement.Addictions.DeActivate',
          id: 'cd131856-990d-4781-9890-1e8f00011401'
        },
        {
          englishName: 'PatientManagement.Allergies.Activate',
          id: '4b80ea4d-4f9a-4c8b-b8b8-6eb593f8a86a'
        },
        {
          englishName: 'SupplierManagement.Hospitals.DeActivate',
          id: '065b634a-3a0b-45f5-a9e3-da8d037ff7d2'
        },
        {
          englishName: 'PatientManagement.Allergies.Read',
          id: '4c1ff8dc-f9b5-4fcb-b474-a9888b14ae17'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.Activate',
          id: '76448b32-2fcc-424b-a8a2-4220a5e3612a'
        },
        {
          englishName: 'PatientManagement.Addictions.Read',
          id: '829f8641-a22c-4536-96b7-db3c19dd6278'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.DeActivate',
          id: 'a4ee2495-1206-4784-8946-333eaa46c020'
        },
        {
          englishName: 'PatientManagement.Diseases.Import',
          id: 'd2cada41-308b-4c2c-aaba-a0f169162a7e'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.Activate',
          id: '42629b79-5f7b-4b0d-88cc-2e7324adb3d3'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.Update',
          id: 'a2bf836c-e664-4286-b5cb-809b17417f7a'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.Create',
          id: 'e91bfdc6-0dad-4776-939e-ae5d3e675428'
        },
        {
          englishName: 'SupplierManagement.Doctors.Read',
          id: '49a0a23f-c48c-40fa-b21b-980ddce5f25e'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.Update',
          id: 'bd7b6303-d3f4-4808-af85-0ec7485186ee'
        },
        {
          englishName: 'SupplierManagement.Hospitals.Update',
          id: '2a98fa05-1437-4583-9376-6039be81022b'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.DeActivate',
          id: '2c14dec0-4e0d-481d-8f29-e3069ffd1b6f'
        },
        {
          englishName: 'PatientManagement.XRays.Activate',
          id: 'cf78f878-42ee-4222-a804-a3d506c47c3b'
        },
        {
          englishName: 'PatientManagement.Diseases.Update',
          id: '49a6938b-7b54-4a45-9921-31238f564784'
        },
        {
          englishName: 'PharmacyManagement.Drugs.Create',
          id: '872fa262-897b-49bd-b63d-1058aaa0deae'
        },
        {
          englishName: 'PatientManagement.Symptoms.RemoveDrug',
          id: 'e5c19435-9208-4c97-8dce-d06f7416ce2d'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.DeActivate',
          id: 'e2fddbab-7f6f-4eac-95c6-ed32b2c7fa75'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.ReadAll',
          id: '6cee56f8-3795-4981-ba6e-e8b6d7500c52'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.Import',
          id: '2a5c1fe7-3eed-408d-ad5b-35a0c3d1cff0'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.DeActivate',
          id: '7862ef61-7511-4234-adc3-4d2ac9806f78'
        },
        {
          englishName: 'SupplierManagement.Hospitals.Create',
          id: '23b7142a-4130-490f-a81a-82c594bb38bf'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.Read',
          id: 'e80e5b94-e43b-4a63-963c-62cd12bfe79e'
        },
        {
          englishName: 'PharmacyManagement.Drugs.DeActivate',
          id: '552ad475-e6ee-4ead-b915-57fa053b94e4'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.DeActivate',
          id: '37e7ea4c-bca9-4794-8587-1877737ad7e4'
        },
        {
          englishName: 'PatientManagement.Symptoms.Update',
          id: '195ecccd-75ba-40d7-93b6-0e9d6a0b245a'
        },
        {
          englishName: 'PatientManagement.Allergies.Create',
          id: 'c884909c-3af1-478b-9169-f8d96c56b3d4'
        },
        {
          englishName: 'PatientManagement.Diseases.DeActivate',
          id: 'f9d4bbfa-7861-4ef5-b1e1-f226b23a0853'
        },
        {
          englishName: 'PatientManagement.Diseases.ReadAll',
          id: '5d573f0e-dea3-4061-9097-ad48e068d934'
        },
        {
          englishName: 'SupplierManagement.Hospitals.ReadAll',
          id: '58d9bde5-8698-4dea-901b-532546f42744'
        },
        {
          englishName: 'PatientManagement.Allergies.DeActivate',
          id: 'b2e9dfbb-14c6-4f50-bd31-8e130fb3c5b8'
        },
        {
          englishName: 'PharmacyManagement.Drugs.Read',
          id: 'd56cb521-e375-4197-938c-63525fbb4ee8'
        },
        {
          englishName: 'PatientManagement.Surgeries.Activate',
          id: '7abf2440-7b44-41e4-be80-d2c34cba8998'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.Update',
          id: 'ce343f81-a71e-4f34-a322-882118953b65'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.Create',
          id: '8d12c9ce-5fd1-4c5d-a7a1-84ee4b98a5e8'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Activate',
          id: '051dd63d-0558-4dc8-a4a3-cb7933d77308'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.Read',
          id: '1f70f714-ded1-4735-908f-48af02bd5597'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.Update',
          id: 'bd80a19a-950d-4b26-bbc6-af29ae669d30'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.Activate',
          id: 'fe59feb3-3546-490a-b778-5d2c02048555'
        },
        {
          englishName: 'PatientManagement.Surgeries.DeActivate',
          id: '317288c1-ff30-44fe-873e-421dd8d4ed5a'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Update',
          id: '1e53e55b-05a0-43bc-8e09-4ca52df64763'
        },
        {
          englishName: 'PatientManagement.Diseases.Read',
          id: '8d226404-09f4-4932-9b0b-32bf2608af56'
        },
        {
          englishName: 'PatientManagement.Addictions.ReadAll',
          id: '8a1d5947-eb2d-47bb-8f95-5a9bc0d2f3dc'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.ReadAll',
          id: '4daecd21-ed04-4efe-9556-f90d3a7e7820'
        },
        {
          englishName: 'PatientManagement.Symptoms.Import',
          id: '829fd243-1c03-4572-9054-e630536828b2'
        },
        {
          englishName: 'PatientManagement.Symptoms.Read',
          id: '7d964f92-52a4-4bd7-be6d-2baa1cea9499'
        },
        {
          englishName: 'PatientManagement.XRays.Import',
          id: '94e68339-efe0-42b7-b1ff-cc80940ae768'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.Update',
          id: '44ffd15b-bfdc-4656-87c0-bfd6cdd258a7'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.Read',
          id: 'e6699e20-74fa-4244-bb72-4cdcd8592bba'
        },
        {
          englishName: 'PatientManagement.Allergies.Update',
          id: '8df13b5f-ea82-4c32-8c0b-91435abcb313'
        },
        {
          englishName: 'PatientManagement.Symptoms.Activate',
          id: 'b703a56f-0d20-402d-b2c7-3481a215d54c'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.Read',
          id: '25d09104-34ce-441c-a63e-e41fe35ab609'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.DeActivate',
          id: 'f374750f-a205-45ce-a06b-55dbd9303f5f'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.Read',
          id: 'ef4c4801-98ab-4e6b-a89e-9d5cc7c7428b'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.ReadAll',
          id: '4ac1190e-c666-45a3-a3fc-c9f9ac4d5582'
        },
        {
          englishName: 'PatientManagement.Addictions.Create',
          id: '3b824c64-6a01-4902-b136-bf57842cce4f'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.Read',
          id: '29cb9146-e14f-4b22-a029-bd6039a667a4'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.Activate',
          id: '7125f732-ffa4-4132-9814-8bed0eeac110'
        },
        {
          englishName: 'PatientManagement.Addictions.Activate',
          id: '7ddd631a-4e81-4e65-818e-b9c19f5746fe'
        }
      ],
      englishName: 'Data Entry',
      id: '67298d2f-eb76-40de-884f-07aabacbd155'
    },
    {
      systemRole: {
        englishName: 'Administrator',
        id: '15ba0880-2438-4f30-8d65-17bd3374bec1'
      },
      permissions: [
        {
          englishName: 'PatientManagement.Symptoms.RemoveDrug',
          id: 'e5c19435-9208-4c97-8dce-d06f7416ce2d'
        },
        {
          englishName: 'PatientManagement.Allergies.Activate',
          id: '4b80ea4d-4f9a-4c8b-b8b8-6eb593f8a86a'
        },
        {
          englishName: 'UserManagement.Users.ReadAll',
          id: '7745b171-a204-4838-91de-fadba5ffa9c7'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.DeActivate',
          id: '7862ef61-7511-4234-adc3-4d2ac9806f78'
        },
        {
          englishName: 'CaseManagement.Cases.EndCall',
          id: '2589fdc1-e717-469c-b8e9-026102c9be3a'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.Activate',
          id: '76448b32-2fcc-424b-a8a2-4220a5e3612a'
        },
        {
          englishName: 'PatientManagement.Addictions.Activate',
          id: '7ddd631a-4e81-4e65-818e-b9c19f5746fe'
        },
        {
          englishName: 'UserManagement.Scopes.ReadAll',
          id: '6b9504d8-8c64-448f-8460-7fa39bf89863'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Create',
          id: 'ca4cf8bd-cdb5-4a54-ad74-b6e83a711a7b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.RemoveAttachment',
          id: '95cc3296-7927-48af-a8d3-91dd269560db'
        },
        {
          englishName: 'UserManagement.Accounts.Scopes.Revoke',
          id: '8473f335-aedf-44c0-95cc-3da76961e88c'
        },
        {
          englishName: 'PharmacyManagement.Drugs.Activate',
          id: '6ca47d03-2bf9-4821-aed0-1858eb47bc8f'
        },
        {
          englishName: 'UserManagement.Scopes.Permissions.Revoke',
          id: '51496c3e-d927-4662-ab81-5cdec13002fd'
        },
        {
          englishName: 'UserManagement.Accounts.ReadAll',
          id: '318a181d-a2ec-4180-bec4-ec6d0c1fd558'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.DeActivate',
          id: '88c945a1-412d-47df-9762-6eea6dd66494'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.Import',
          id: '2a5c1fe7-3eed-408d-ad5b-35a0c3d1cff0'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.VisitHospitalRecommendations.Create',
          id: 'd95877a0-68fa-4eb8-aad7-2f5cdaf1d937'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.Read',
          id: '29cb9146-e14f-4b22-a029-bd6039a667a4'
        },
        {
          englishName: 'UserManagement.Accounts.Users.Create',
          id: '31bbbd00-2ea2-49fd-bcaa-4864849e73ba'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.ReadAll',
          id: '4daecd21-ed04-4efe-9556-f90d3a7e7820'
        },
        {
          englishName: 'PatientManagement.Symptoms.Create',
          id: '9a3bad69-5a98-4a9a-b5d9-10f1adf4564a'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.ReadAll',
          id: '07429ce9-64b7-471f-9ceb-cc0eed378527'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Read',
          id: '84f5f633-f3a9-458a-9d4a-07c9853596e4'
        },
        {
          englishName: 'UserManagement.Scopes.Read',
          id: '30cd46ca-77ea-4a59-91dd-7bb15a40111b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Update',
          id: '05318759-fc0e-43b3-80d1-4e676b94125f'
        },
        {
          englishName: 'SupplierManagement.Hospitals.ReadAll',
          id: '58d9bde5-8698-4dea-901b-532546f42744'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.ReadAll',
          id: '107e4459-fce2-4368-a23f-de551285d68c'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Read',
          id: 'a16a8984-e124-47c2-a7c2-0e7d36391bae'
        },
        {
          englishName: 'UserManagement.Accounts.Users.SpecializedRoles.Assign',
          id: '537b1c80-35da-44fc-a966-2ab4a50221cb'
        },
        {
          englishName: 'CaseManagement.Cases.Read',
          id: '4907c9ab-0c55-4b87-97f4-7de4273597fb'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.Create',
          id: 'cd022a9b-ec17-40a6-8f10-49c0a1b45f9a'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.ReadAll',
          id: '6cee56f8-3795-4981-ba6e-e8b6d7500c52'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Read',
          id: '8f839465-15c6-46de-8b87-0418383d33eb'
        },
        {
          englishName: 'PatientManagement.Diseases.Import',
          id: 'd2cada41-308b-4c2c-aaba-a0f169162a7e'
        },
        {
          englishName: 'CaseManagement.Cases.Create',
          id: '3ff9d635-efb8-4a19-908e-a63cc80d9605'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.ReadAll',
          id: '4cc35a8a-a9da-4661-981a-416ba469a9fb'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.Update',
          id: 'bd80a19a-950d-4b26-bbc6-af29ae669d30'
        },
        {
          englishName: 'PharmacyManagement.Drugs.Update',
          id: '0edd86a8-9ffb-46ab-a171-dca191192a57'
        },
        {
          englishName: 'CaseManagement.Cases.Delete',
          id: 'c1b3dd34-9f5c-456c-b7a3-1e91433ba64b'
        },
        {
          englishName: 'OrderManagement.Orders.Create',
          id: '15759108-47f8-4530-901e-0b61cc48c629'
        },
        {
          englishName: 'PatientManagement.Allergies.Import',
          id: '8694a366-5932-4fc7-9446-b2d9eaf429bd'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.Read',
          id: 'ef4c4801-98ab-4e6b-a89e-9d5cc7c7428b'
        },
        {
          englishName: 'SupplierManagement.Doctors.Update',
          id: 'a4285f66-93a2-459a-9ed2-6fb359d4da53'
        },
        {
          englishName: 'SupplierManagement.Doctors.ReadAll',
          id: '0101e959-49a0-4b49-8daa-033a8f8bc9db'
        },
        {
          englishName: 'PatientManagement.Diseases.Activate',
          id: '49557d1a-20c1-4f8e-a37e-84bc088161a0'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.Create',
          id: '9617bac1-e20a-4619-b5f5-a3c10270d0fa'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Delete',
          id: 'b18b6321-b32d-42e4-b244-dc5c681b37d4'
        },
        {
          englishName: 'UserManagement.Accounts.Users.Update',
          id: '68c4d162-3434-4cf3-af11-8160412a06e3'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.Update',
          id: '02112746-8242-4252-b056-4c2d0697ad6e'
        },
        {
          englishName: 'PatientManagement.XRays.Activate',
          id: 'cf78f878-42ee-4222-a804-a3d506c47c3b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Statistics',
          id: '36408604-3c19-4abe-8e91-f359f3b4f0e1'
        },
        {
          englishName: 'SupplierManagement.Hospitals.Create',
          id: '23b7142a-4130-490f-a81a-82c594bb38bf'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.Update',
          id: 'd95f964d-6979-40bd-89a5-78d4d13582f1'
        },
        {
          englishName: 'PatientManagement.Addictions.Create',
          id: '3b824c64-6a01-4902-b136-bf57842cce4f'
        },
        {
          englishName: 'PatientManagement.Diseases.Create',
          id: 'e210c609-467b-492b-9632-37c6cdd9b125'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.ReadAll',
          id: '4ac1190e-c666-45a3-a3fc-c9f9ac4d5582'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.ReadAll',
          id: 'f406b7a6-a766-42d4-bc2d-f90d2b3b30a4'
        },
        {
          englishName: 'UserManagement.Accounts.Users.ReadAll',
          id: '1e8f0567-b4dd-464c-a9e4-e57d02ceee3b'
        },
        {
          englishName: 'CaseManagement.Cases.ReadMyCases',
          id: '0a607daa-c85e-4461-bddc-fb9ed0b091ad'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.Activate',
          id: 'cb828ba5-1da1-4e75-83fe-26aa69e800e6'
        },
        {
          englishName: 'PatientManagement.Symptoms.Update',
          id: '195ecccd-75ba-40d7-93b6-0e9d6a0b245a'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Delete',
          id: 'a6173827-c86c-4961-9cff-b999bc5b93c5'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.ReadAll',
          id: '14c9ca3a-94a6-44d9-869f-147db13cf0e6'
        },
        {
          englishName: 'PatientManagement.Symptoms.Import',
          id: '829fd243-1c03-4572-9054-e630536828b2'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.DeActivate',
          id: 'e2fddbab-7f6f-4eac-95c6-ed32b2c7fa75'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.Create',
          id: 'c2fe5690-07b7-4ff9-b867-d372a4c3a025'
        },
        {
          englishName: 'CaseManagement.Cases.StartCall',
          id: '39222ce9-f23e-4779-a54f-04336773b81f'
        },
        {
          englishName: 'CaseManagement.Cases.Resolve',
          id: '437c9e2b-78e5-4d7d-a4e0-ae0cc8a5db6a'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.Read',
          id: 'e6699e20-74fa-4244-bb72-4cdcd8592bba'
        },
        {
          englishName: 'CaseManagement.Cases.RemoveAttachment',
          id: '1c693900-35fd-47a2-b7a1-6a27c6da8817'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.Activate',
          id: 'f522684f-8981-43ba-975d-9695ebbce5ee'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Update',
          id: '9a7d9846-23f4-4fc7-a0dc-1f4c4d7372d2'
        },
        {
          englishName: 'PatientManagement.Allergies.Update',
          id: '8df13b5f-ea82-4c32-8c0b-91435abcb313'
        },
        {
          englishName: 'PatientManagement.XRays.Create',
          id: '5195d4e6-a040-425c-b970-ae64c75bf13b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Delete',
          id: '843b5d3d-1f6c-4bd0-ae48-906b62a7efec'
        },
        {
          englishName: 'PatientManagement.XRays.ReadAll',
          id: 'bef27c7a-deed-492b-85eb-31eadeccd60d'
        },
        {
          englishName: 'UserManagement.Accounts.Create',
          id: 'b31e2b85-0c62-4405-a47b-35308ee3418f'
        },
        {
          englishName: 'CaseManagement.Cases.Pick',
          id: '4ff0b185-c87c-4cfe-b73b-7631b850ded2'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Read',
          id: '1f0d0e89-7a8e-4e6c-b53d-ee9387f85544'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.ReadAll',
          id: '1c1ca879-9f80-4feb-bc5e-d098e714e240'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.Activate',
          id: '42629b79-5f7b-4b0d-88cc-2e7324adb3d3'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Create',
          id: 'ecb1a75b-9f74-4fca-b3d7-9cdde4c2c16d'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.Activate',
          id: '7125f732-ffa4-4132-9814-8bed0eeac110'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Create',
          id: 'c70db49d-87d0-44ec-a4af-4a4daee16d1e'
        },
        {
          englishName: 'UserManagement.Users.Read',
          id: 'f4d94080-6edc-4b5f-9ff2-5eac5f69c3f2'
        },
        {
          englishName: 'UserManagement.Accounts.SpecializedRoles.Permissions.ReadAll',
          id: '3a2028eb-ceed-4835-a0a6-16719fc66f4c'
        },
        {
          englishName: 'UserManagement.Accounts.Users.ChangePassword',
          id: 'ffa2dd6c-4324-48b6-ab8c-fedf5fc0c834'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.ReadAll',
          id: '2b002274-82a0-4657-994a-9ec3fa50413c'
        },
        {
          englishName: 'UserManagement.Accounts.Scopes.Assign',
          id: '19db9787-2591-4561-b566-4952cad0ab48'
        },
        {
          englishName: 'PatientManagement.Addictions.Update',
          id: '02e56ebf-1fe6-4561-86a9-4e338c9b10b5'
        },
        {
          englishName: 'PatientManagement.Surgeries.Read',
          id: '843c8c89-4965-4778-b88d-b3ae698e308a'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Delete',
          id: '09b2ae0c-4e94-44d3-8789-404c799dd98d'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Read',
          id: '383ce616-9b2a-48b2-b7d5-bea39c393ebf'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.Update',
          id: 'bd7b6303-d3f4-4808-af85-0ec7485186ee'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.Update',
          id: '7ccf621f-7111-4f73-b336-94e76f20db00'
        },
        {
          englishName: 'UserManagement.Scopes.Permissions.Assign',
          id: 'efba2779-c710-44f9-9b19-d4862fb43170'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Read',
          id: '948ccb6f-6575-4e4a-8061-a8dadb825436'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.Update',
          id: 'dd961ebc-5ac7-41f3-b045-cbd531ec4482'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.DeActivate',
          id: 'a4ee2495-1206-4784-8946-333eaa46c020'
        },
        {
          englishName: 'UtilityManagement.Attachments.Create',
          id: '5521ed9b-cd88-46c8-97fe-9fb6c17e6a53'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Read',
          id: 'e67f22ad-f8a7-4f8c-907d-c8a996f523e3'
        },
        {
          englishName: 'CaseManagement.Cases.ReadAll',
          id: '82c4cb9d-b851-4a26-89d9-d3824051b555'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.Update',
          id: 'ce343f81-a71e-4f34-a322-882118953b65'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.DeActivate',
          id: '2c14dec0-4e0d-481d-8f29-e3069ffd1b6f'
        },
        {
          englishName: 'UserManagement.Accounts.SpecializedRoles.Update',
          id: '4649af1a-2025-40ab-820e-f7442644ab6d'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Create',
          id: 'f28d756e-72ab-4edc-88b0-705cbbc03b40'
        },
        {
          englishName: 'PatientManagement.Surgeries.Activate',
          id: '7abf2440-7b44-41e4-be80-d2c34cba8998'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.AddAttachment',
          id: '0652e56a-0450-42ce-a5e3-0bc152591000'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.Update',
          id: '458b5499-3ff3-4891-abd0-6b5c2de1f0fd'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.DeActivate',
          id: 'f374750f-a205-45ce-a06b-55dbd9303f5f'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.Read',
          id: '403f0c5b-e4bd-4b73-a000-f4c55527929e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Delete',
          id: 'a736e0f8-02c3-4ab0-817a-b0219b44610a'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Update',
          id: '47ba269e-c88b-4807-9c7c-3f08f8e6d5ae'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Update',
          id: 'ed4b2f4a-b168-4247-836a-7045a580d8fe'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.ReadAll',
          id: 'c1d36c28-d7b7-4ec6-83a5-53f41d560420'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Read',
          id: 'c84c8f43-8fc0-4d65-8303-e3e805f783d3'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Delete',
          id: '8b79e557-c32b-437c-bf2b-1f57f1c2b414'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.Activate',
          id: '0f90b32a-c44d-4d1c-82b3-83030dfa8290'
        },
        {
          englishName: 'UserManagement.Accounts.SpecializedRoles.Permissions.Assign',
          id: '942defe4-dcfb-44bd-a708-3d402babe02c'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.XrayVisitRecommendations.Create',
          id: '481c8022-9b65-4cf6-9a7f-0702265bb83d'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.Read',
          id: 'df441d01-d694-4012-be80-61e7b7b734b7'
        },
        {
          englishName: 'PatientManagement.Surgeries.Update',
          id: '4bb02be1-b34b-4cdd-8370-627b9f4ad3cd'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.AddDrug',
          id: 'a2ade989-7dd9-4e04-9f57-80069b0ff670'
        },
        {
          englishName: 'UserManagement.Accounts.SpecializedRoles.Permissions.Revoke',
          id: 'abd443dd-3971-4b7d-ad91-dd964b0a3952'
        },
        {
          englishName: 'PharmacyManagement.Drugs.Read',
          id: 'd56cb521-e375-4197-938c-63525fbb4ee8'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.DeActivate',
          id: '489da94a-d917-494c-8663-b3809fb971ee'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Create',
          id: 'd6e3bd9a-4f2f-4ed7-83e2-465ee70baab6'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Create',
          id: '5c75399d-0561-42ea-8f23-7b84c33385ca'
        },
        {
          englishName: 'PharmacyManagement.Drugs.ReadAll',
          id: 'ae0c99f8-a596-453c-a1fc-be9274226805'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Create',
          id: 'a254e5a6-b572-4ea2-b943-fc372cd84012'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.Read',
          id: '25d09104-34ce-441c-a63e-e41fe35ab609'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Update',
          id: '4d231dcb-b6d7-47b1-9840-18d270269f1f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Update',
          id: 'e22d2692-1071-4b1e-80d5-7394daec3e0b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Update',
          id: '1cc31b62-c4fd-44d2-a338-e041f29d4af1'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.Activate',
          id: '815fc778-a4f4-4f5f-b1f3-2f070bd61c4a'
        },
        {
          englishName: 'PatientManagement.Symptoms.DeActivate',
          id: 'b62235bb-24b0-4f25-adc3-f29cfe7fbb08'
        },
        {
          englishName: 'SupplierManagement.Hospitals.Read',
          id: 'eb368ee7-2dee-41a3-8cef-3995d9f577e7'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Update',
          id: '1b440cb3-4bb2-4c3c-9622-1d90e95f28a0'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Activate',
          id: '051dd63d-0558-4dc8-a4a3-cb7933d77308'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.Create',
          id: '20438ba8-0793-4da1-8928-5ca6eac10484'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Update',
          id: '1e53e55b-05a0-43bc-8e09-4ca52df64763'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.Activate',
          id: 'fe59feb3-3546-490a-b778-5d2c02048555'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Read',
          id: '7f379288-803c-41ea-ad64-14a0a1b5eb7f'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.Delete',
          id: '484b462d-7cb0-4025-a270-208d69548ab5'
        },
        {
          englishName: 'UserManagement.Accounts.Users.Read',
          id: '43c44126-3cc1-4b95-b487-e8f090f34518'
        },
        {
          englishName: 'SupplierManagement.Hospitals.Update',
          id: '2a98fa05-1437-4583-9376-6039be81022b'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.VisitSpecializedDoctorRecommendations.Create',
          id: '17a6c269-8635-4e83-b0c2-5c8a71913161'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.Update',
          id: 'a2bf836c-e664-4286-b5cb-809b17417f7a'
        },
        {
          englishName: 'UserManagement.Scopes.Update',
          id: 'cd55df04-eb5c-4179-b859-3588cf82c04d'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Update',
          id: '124e91c6-b3b0-4377-ac51-787ad84faae5'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.Activate',
          id: '617764db-be81-4bd3-b6c8-f9bbccdef5c3'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Create',
          id: 'b209e101-75bc-4685-863f-583cba497029'
        },
        {
          englishName: 'UserManagement.Accounts.SpecializedRoles.Read',
          id: '57a6f234-7d84-4b4b-880f-a27070905e38'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Delete',
          id: '8c85a1e5-ac7c-43c4-858c-70f90465707b'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.Create',
          id: '716f8191-c53a-4793-8666-0e9e1fecbdf9'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.Activate',
          id: 'c981bc27-bf86-49a5-9fba-25a614c72fa4'
        },
        {
          englishName: 'PatientManagement.Diseases.Read',
          id: '8d226404-09f4-4932-9b0b-32bf2608af56'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.InstructionsRecommendations.Create',
          id: '1ff38507-cc99-4442-8658-99dee989db51'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Create',
          id: '2de25423-1b01-4a4f-aa64-2b33fcae3d9e'
        },
        {
          englishName: 'SupplierManagement.Doctors.Read',
          id: '49a0a23f-c48c-40fa-b21b-980ddce5f25e'
        },
        {
          englishName: 'SupplierManagement.Doctors.Create',
          id: '43113c9f-0af7-405b-bdc2-d44bf4282b32'
        },
        {
          englishName: 'UserManagement.Scopes.Permissions.ReadAll',
          id: 'bc32f7f7-e876-4d4b-8650-d846d7512117'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Update',
          id: '5c210591-3a81-4f8a-8a52-10ee16bf6f13'
        },
        {
          englishName: 'CaseManagement.Cases.Cancel',
          id: '312688cf-e00f-4c44-bd5a-8a9ad54c0c2d'
        },
        {
          englishName: 'PatientManagement.Surgeries.Import',
          id: '8bb968c1-c29e-40ea-8c08-9c870697b033'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Delete',
          id: '86de5594-df7c-4819-b631-8fac13f12671'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Delete',
          id: 'fc413095-5550-4f7b-b593-8966db3651c1'
        },
        {
          englishName: 'PatientManagement.Addictions.ReadAll',
          id: '8a1d5947-eb2d-47bb-8f95-5a9bc0d2f3dc'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.Create',
          id: 'a23593d5-79db-440e-a86c-691da112bcc9'
        },
        {
          englishName: 'SupplierManagement.Doctors.Activate',
          id: 'cec1b0fd-b8ca-4e33-8d14-9a3ec34dd80b'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.Create',
          id: 'cc5bd4e5-7bb4-4ae6-9672-0f5c560ab7db'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.DeActivate',
          id: '1abbd14f-64eb-45f3-8ec7-6f84cf9eeb3e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Delete',
          id: '72ea4ab9-be6f-42b5-b67b-1270f3aafa18'
        },
        {
          englishName: 'UserManagement.Scopes.Create',
          id: '3086638a-04d4-44bb-a633-ab7bcc99ab59'
        },
        {
          englishName: 'UserManagement.Accounts.SpecializedRoles.Create',
          id: '8d7ecac3-6120-4df2-92de-e796aca62e22'
        },
        {
          englishName: 'PharmacyManagement.Drugs.Create',
          id: '872fa262-897b-49bd-b63d-1058aaa0deae'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.ReadAll',
          id: '18ff90f3-79dc-4657-80f6-5d01a339d44e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Create',
          id: '7cad122b-7b6d-4293-a22e-0a8c87d8905f'
        },
        {
          englishName: 'PatientManagement.Surgeries.ReadAll',
          id: 'a41c9af2-eb63-4e9a-a357-ca9c0db6852c'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.DeActivate',
          id: '37e7ea4c-bca9-4794-8587-1877737ad7e4'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.DeActivate',
          id: '1f35334d-d760-4116-a193-fcf2b4dbc806'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.ReadAll',
          id: 'df3cdc5e-5014-473f-a005-32ff03a8c2dc'
        },
        {
          englishName: 'PatientManagement.Diseases.Update',
          id: '49a6938b-7b54-4a45-9921-31238f564784'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Update',
          id: '9716dc25-aff5-4354-9b47-261abf13cf70'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.DeActivate',
          id: 'dcdaed09-5a2e-4743-9e71-4a5d2dd2dfeb'
        },
        {
          englishName: 'CaseManagement.Cases.ReadCaseLookups',
          id: 'eacc1001-283a-4ae9-9d21-61dc5eac6ccb'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.Create',
          id: '8d12c9ce-5fd1-4c5d-a7a1-84ee4b98a5e8'
        },
        {
          englishName: 'PatientManagement.XRays.DeActivate',
          id: '133c73ca-5c71-465c-b047-465577c414f3'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Create',
          id: '4d51562a-9365-455c-94a1-be412dda14e4'
        },
        {
          englishName: 'SupplierManagement.Hospitals.DeActivate',
          id: '065b634a-3a0b-45f5-a9e3-da8d037ff7d2'
        },
        {
          englishName: 'SupplierManagement.Doctors.DeActivate',
          id: 'c53f1421-bfd3-4378-959b-9c29e8ad9fae'
        },
        {
          englishName: 'CaseManagement.Cases.Update',
          id: 'fd4b45c6-8395-4cd0-a61d-0b415c598941'
        },
        {
          englishName: 'PatientManagement.Surgeries.Create',
          id: '4a192605-0372-4d15-81c0-16b98118fc70'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Read',
          id: 'e96ff4b4-939a-47b2-95e0-51219af7ccba'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.ReadAll',
          id: '80031ffc-3ade-4488-a7ae-5b00fc746137'
        },
        {
          englishName: 'UserManagement.Accounts.Users.SpecializedRoles.Revoke',
          id: '7fa8b04f-23b1-4687-9b33-79863b939a88'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Create',
          id: '944f7c45-f2ad-402f-982f-c8787a1ae9b1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Read',
          id: 'e49a5772-ebd1-4d9a-ad68-48ea628f557c'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.Create',
          id: '882ef2af-56f1-4c0f-b52e-cfbfa2139a4b'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.Read',
          id: 'e80e5b94-e43b-4a63-963c-62cd12bfe79e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Create',
          id: '881f1c2e-44c0-4e95-bbed-56c98bfd4daf'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientRelatedProfiles.ReadAll',
          id: 'ad520aba-8632-42ff-b5a6-aa472d658315'
        },
        {
          englishName: 'PatientManagement.Allergies.ReadAll',
          id: '7d46fca5-bd62-43c7-b053-57da68c7ace5'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Delete',
          id: '4b350527-9099-4bdf-a32a-51f98ef73ae7'
        },
        {
          englishName: 'PatientManagement.Addictions.Read',
          id: '829f8641-a22c-4536-96b7-db3c19dd6278'
        },
        {
          englishName: 'PatientManagement.Surgeries.DeActivate',
          id: '317288c1-ff30-44fe-873e-421dd8d4ed5a'
        },
        {
          englishName: 'PatientManagement.Addictions.DeActivate',
          id: 'cd131856-990d-4781-9890-1e8f00011401'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.RemoveDrug',
          id: '5da3e2e4-ef08-4680-b153-a9ecaf03ffd2'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.Read',
          id: 'c4222ad7-8d31-4c6a-ab30-849263a93a1e'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.Update',
          id: '44ffd15b-bfdc-4656-87c0-bfd6cdd258a7'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.ReadAll',
          id: '6056fc19-8812-4701-92d7-b424da47db82'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.ReadAll',
          id: 'bcbd4efb-a055-46ab-bcb4-600cc9dea85d'
        },
        {
          englishName: 'PatientManagement.Symptoms.Read',
          id: '7d964f92-52a4-4bd7-be6d-2baa1cea9499'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Delete',
          id: '9d38aec1-ad13-4082-8bb4-7ef5c5eb70a1'
        },
        {
          englishName: 'PatientManagement.XRays.Update',
          id: '4a5103c4-6e5e-4c22-bc4b-d3d377a02a5f'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.Read',
          id: '1f70f714-ded1-4735-908f-48af02bd5597'
        },
        {
          englishName: 'PatientManagement.Symptoms.Activate',
          id: 'b703a56f-0d20-402d-b2c7-3481a215d54c'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientRelatedProfiles.Create',
          id: 'fac4b038-a649-4f9c-a914-7cba155eb86c'
        },
        {
          englishName: 'PatientManagement.Allergies.Create',
          id: 'c884909c-3af1-478b-9169-f8d96c56b3d4'
        },
        {
          englishName: 'PatientManagement.Allergies.Read',
          id: '4c1ff8dc-f9b5-4fcb-b474-a9888b14ae17'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Delete',
          id: '990d0f0f-0874-4486-a861-393fb97d3cc5'
        },
        {
          englishName: 'SupplierManagement.Hospitals.Activate',
          id: 'd096403c-5cbc-4d62-9f4c-cd1c35441316'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Create',
          id: '2320ece1-52b5-4b2f-8edc-6b9ebedae7b4'
        },
        {
          englishName: 'PatientManagement.Symptoms.ReadAll',
          id: '6b9b7295-6f5e-4e93-8f28-71991afbb90e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.ReadAll',
          id: 'a59653dd-778c-4f9a-a352-c5813df8cb8a'
        },
        {
          englishName: 'CaseManagement.Cases.AddAttachment',
          id: '318fe770-a6ae-41c7-9f08-7c7daf115b0f'
        },
        {
          englishName: 'PatientManagement.Symptoms.AddDrug',
          id: 'da300683-8cfb-439b-afe8-2a21049710d0'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Read',
          id: '39ff901e-00db-4ba1-b323-ad2773fceaa4'
        },
        {
          englishName: 'UserManagement.SystemRoles.ReadAll',
          id: '48f3ab36-3032-43de-bcce-684564e95d86'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.Create',
          id: 'e91bfdc6-0dad-4776-939e-ae5d3e675428'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Read',
          id: 'd9ecfe9e-f8e7-4af3-8529-c1d8352875f1'
        },
        {
          englishName: 'UserManagement.Accounts.Read',
          id: '1386fc3f-5ca2-46c5-9918-a6a9c0ef1c60'
        },
        {
          englishName: 'UserManagement.Permissions.ReadAll',
          id: '9dae12c6-a513-4671-97f7-91bbd203cce9'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.ReadAll',
          id: 'c2c39be1-db3b-4970-9f3f-ab8bdeabebf1'
        },
        {
          englishName: 'PharmacyManagement.Drugs.DeActivate',
          id: '552ad475-e6ee-4ead-b915-57fa053b94e4'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Create',
          id: '6a3c779f-fcb2-4e65-9dc3-48fcd5664491'
        },
        {
          englishName: 'PatientManagement.XRays.Read',
          id: '77ff5753-3c54-4b8a-94e3-286d2ac9ebac'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.CaseMedicationsRecommendations.Read',
          id: 'a1d6c181-f28e-4339-b24c-2d5b2fbd74ef'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.Read',
          id: '187005d5-9779-49ce-9607-9daa49245822'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.ReadAll',
          id: '5096afe7-b17f-465f-a844-25e8e6211c80'
        },
        {
          englishName: 'PatientManagement.Allergies.DeActivate',
          id: 'b2e9dfbb-14c6-4f50-bd31-8e130fb3c5b8'
        },
        {
          englishName: 'UserManagement.Accounts.SpecializedRoles.ReadAll',
          id: '762775b6-f461-410d-b724-a46e425c75b0'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.LabVisitRecommendations.Create',
          id: 'f295bd7e-1630-49f1-9df6-25559d30df31'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Update',
          id: 'a1141730-ae52-4439-a331-000721f23d4a'
        },
        {
          englishName: 'UserManagement.Accounts.Update',
          id: 'c6c2c96f-25b7-49bd-b264-c85e6661226c'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.ReadAll',
          id: '205015ea-eeee-46aa-b036-fa954d27d253'
        },
        {
          englishName: 'PatientManagement.XRays.Import',
          id: '94e68339-efe0-42b7-b1ff-cc80940ae768'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Update',
          id: 'dd54fd3f-49c4-4603-9832-a78dcf09532d'
        },
        {
          englishName: 'PatientManagement.Diseases.ReadAll',
          id: '5d573f0e-dea3-4061-9097-ad48e068d934'
        },
        {
          englishName: 'UtilityManagement.Attachments.Read',
          id: '860699e1-5f45-4ca9-9674-32b742b29b38'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.ReadAll',
          id: 'bd6033b1-a99b-4263-b553-98c1872802b1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Update',
          id: '866def7b-dd09-47e9-9108-affafba23536'
        },
        {
          englishName: 'PatientManagement.Diseases.DeActivate',
          id: 'f9d4bbfa-7861-4ef5-b1e1-f226b23a0853'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.ReadAll',
          id: '9766fb16-a221-4ad8-b1c5-61d12c4edcc3'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.ReadAll',
          id: '5d32a82f-7d7b-42d7-a727-981a1388c7f7'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Delete',
          id: '4bec520c-119b-4170-b2e2-af1b3ec8dd47'
        }
      ],
      englishName: 'Administrator',
      id: '5168d7e8-9961-498e-8d5d-3e31109c86c6'
    },
    {
      systemRole: {
        englishName: 'PediatricianDoctor',
        id: '2db693b3-f35f-42be-bf2d-adeb034da3ae'
      },
      permissions: [
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Create',
          id: '881f1c2e-44c0-4e95-bbed-56c98bfd4daf'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientRelatedProfiles.Create',
          id: 'fac4b038-a649-4f9c-a914-7cba155eb86c'
        },
        {
          englishName: 'SupplierManagement.Hospitals.Read',
          id: 'eb368ee7-2dee-41a3-8cef-3995d9f577e7'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Delete',
          id: '4b350527-9099-4bdf-a32a-51f98ef73ae7'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Delete',
          id: 'a6173827-c86c-4961-9cff-b999bc5b93c5'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Create',
          id: 'a254e5a6-b572-4ea2-b943-fc372cd84012'
        },
        {
          englishName: 'CaseManagement.Cases.EndCall',
          id: '2589fdc1-e717-469c-b8e9-026102c9be3a'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.ReadAll',
          id: '9766fb16-a221-4ad8-b1c5-61d12c4edcc3'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Update',
          id: '05318759-fc0e-43b3-80d1-4e676b94125f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Read',
          id: '948ccb6f-6575-4e4a-8061-a8dadb825436'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Update',
          id: 'e22d2692-1071-4b1e-80d5-7394daec3e0b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Delete',
          id: '4bec520c-119b-4170-b2e2-af1b3ec8dd47'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.ReadAll',
          id: '07429ce9-64b7-471f-9ceb-cc0eed378527'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.XrayVisitRecommendations.Create',
          id: '481c8022-9b65-4cf6-9a7f-0702265bb83d'
        },
        {
          englishName: 'PatientManagement.Diseases.ReadAll',
          id: '5d573f0e-dea3-4061-9097-ad48e068d934'
        },
        {
          englishName: 'PharmacyManagement.Drugs.Read',
          id: 'd56cb521-e375-4197-938c-63525fbb4ee8'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Read',
          id: '7f379288-803c-41ea-ad64-14a0a1b5eb7f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Delete',
          id: '8b79e557-c32b-437c-bf2b-1f57f1c2b414'
        },
        {
          englishName: 'UtilityManagement.Attachments.Create',
          id: '5521ed9b-cd88-46c8-97fe-9fb6c17e6a53'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Update',
          id: '5c210591-3a81-4f8a-8a52-10ee16bf6f13'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.ReadAll',
          id: '14c9ca3a-94a6-44d9-869f-147db13cf0e6'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.Delete',
          id: '484b462d-7cb0-4025-a270-208d69548ab5'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.LabVisitRecommendations.Create',
          id: 'f295bd7e-1630-49f1-9df6-25559d30df31'
        },
        {
          englishName: 'CaseManagement.Cases.ReadCaseLookups',
          id: 'eacc1001-283a-4ae9-9d21-61dc5eac6ccb'
        },
        {
          englishName: 'PatientManagement.Addictions.Read',
          id: '829f8641-a22c-4536-96b7-db3c19dd6278'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.VisitSpecializedDoctorRecommendations.Create',
          id: '17a6c269-8635-4e83-b0c2-5c8a71913161'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.ReadAll',
          id: '5d32a82f-7d7b-42d7-a727-981a1388c7f7'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.ReadAll',
          id: '6056fc19-8812-4701-92d7-b424da47db82'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.Read',
          id: 'e6699e20-74fa-4244-bb72-4cdcd8592bba'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Update',
          id: 'a1141730-ae52-4439-a331-000721f23d4a'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.ReadAll',
          id: '1c1ca879-9f80-4feb-bc5e-d098e714e240'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Update',
          id: '1b440cb3-4bb2-4c3c-9622-1d90e95f28a0'
        },
        {
          englishName: 'CaseManagement.Cases.ReadAll',
          id: '82c4cb9d-b851-4a26-89d9-d3824051b555'
        },
        {
          englishName: 'CaseManagement.Cases.Read',
          id: '4907c9ab-0c55-4b87-97f4-7de4273597fb'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Read',
          id: '1f0d0e89-7a8e-4e6c-b53d-ee9387f85544'
        },
        {
          englishName: 'CaseManagement.Cases.Update',
          id: 'fd4b45c6-8395-4cd0-a61d-0b415c598941'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Create',
          id: 'f28d756e-72ab-4edc-88b0-705cbbc03b40'
        },
        {
          englishName: 'PatientManagement.Surgeries.ReadAll',
          id: 'a41c9af2-eb63-4e9a-a357-ca9c0db6852c'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Delete',
          id: '8c85a1e5-ac7c-43c4-858c-70f90465707b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Read',
          id: 'c84c8f43-8fc0-4d65-8303-e3e805f783d3'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.ReadAll',
          id: '4ac1190e-c666-45a3-a3fc-c9f9ac4d5582'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Create',
          id: '7cad122b-7b6d-4293-a22e-0a8c87d8905f'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.ReadAll',
          id: 'c2c39be1-db3b-4970-9f3f-ab8bdeabebf1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.ReadAll',
          id: 'a59653dd-778c-4f9a-a352-c5813df8cb8a'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.Read',
          id: '25d09104-34ce-441c-a63e-e41fe35ab609'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Create',
          id: '6a3c779f-fcb2-4e65-9dc3-48fcd5664491'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Update',
          id: 'ed4b2f4a-b168-4247-836a-7045a580d8fe'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.VisitHospitalRecommendations.Create',
          id: 'd95877a0-68fa-4eb8-aad7-2f5cdaf1d937'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Delete',
          id: '990d0f0f-0874-4486-a861-393fb97d3cc5'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.ReadAll',
          id: '6cee56f8-3795-4981-ba6e-e8b6d7500c52'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Delete',
          id: '843b5d3d-1f6c-4bd0-ae48-906b62a7efec'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Delete',
          id: 'b18b6321-b32d-42e4-b244-dc5c681b37d4'
        },
        {
          englishName: 'PatientManagement.Addictions.ReadAll',
          id: '8a1d5947-eb2d-47bb-8f95-5a9bc0d2f3dc'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Read',
          id: 'e67f22ad-f8a7-4f8c-907d-c8a996f523e3'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Read',
          id: '383ce616-9b2a-48b2-b7d5-bea39c393ebf'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.AddAttachment',
          id: '0652e56a-0450-42ce-a5e3-0bc152591000'
        },
        {
          englishName: 'CaseManagement.Cases.Cancel',
          id: '312688cf-e00f-4c44-bd5a-8a9ad54c0c2d'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Read',
          id: 'd9ecfe9e-f8e7-4af3-8529-c1d8352875f1'
        },
        {
          englishName: 'SupplierManagement.Hospitals.ReadAll',
          id: '58d9bde5-8698-4dea-901b-532546f42744'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.InstructionsRecommendations.Create',
          id: '1ff38507-cc99-4442-8658-99dee989db51'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Update',
          id: '1cc31b62-c4fd-44d2-a338-e041f29d4af1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Delete',
          id: 'a736e0f8-02c3-4ab0-817a-b0219b44610a'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.ReadAll',
          id: 'bd6033b1-a99b-4263-b553-98c1872802b1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Delete',
          id: '9d38aec1-ad13-4082-8bb4-7ef5c5eb70a1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.ReadAll',
          id: 'df3cdc5e-5014-473f-a005-32ff03a8c2dc'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Read',
          id: '84f5f633-f3a9-458a-9d4a-07c9853596e4'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.ReadAll',
          id: '5096afe7-b17f-465f-a844-25e8e6211c80'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Read',
          id: 'e49a5772-ebd1-4d9a-ad68-48ea628f557c'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.ReadAll',
          id: '18ff90f3-79dc-4657-80f6-5d01a339d44e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Create',
          id: 'ecb1a75b-9f74-4fca-b3d7-9cdde4c2c16d'
        },
        {
          englishName: 'CaseManagement.Cases.ReadMyCases',
          id: '0a607daa-c85e-4461-bddc-fb9ed0b091ad'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.ReadAll',
          id: 'c1d36c28-d7b7-4ec6-83a5-53f41d560420'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Create',
          id: 'd6e3bd9a-4f2f-4ed7-83e2-465ee70baab6'
        },
        {
          englishName: 'CaseManagement.Cases.RemoveAttachment',
          id: '1c693900-35fd-47a2-b7a1-6a27c6da8817'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.ReadAll',
          id: '205015ea-eeee-46aa-b036-fa954d27d253'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.ReadAll',
          id: '4cc35a8a-a9da-4661-981a-416ba469a9fb'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.ReadAll',
          id: 'bcbd4efb-a055-46ab-bcb4-600cc9dea85d'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Create',
          id: 'b209e101-75bc-4685-863f-583cba497029'
        },
        {
          englishName: 'SupplierManagement.Doctors.ReadAll',
          id: '0101e959-49a0-4b49-8daa-033a8f8bc9db'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientRelatedProfiles.ReadAll',
          id: 'ad520aba-8632-42ff-b5a6-aa472d658315'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Read',
          id: 'e96ff4b4-939a-47b2-95e0-51219af7ccba'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.Read',
          id: '403f0c5b-e4bd-4b73-a000-f4c55527929e'
        },
        {
          englishName: 'SupplierManagement.Doctors.Read',
          id: '49a0a23f-c48c-40fa-b21b-980ddce5f25e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.ReadAll',
          id: '80031ffc-3ade-4488-a7ae-5b00fc746137'
        },
        {
          englishName: 'CaseManagement.Cases.StartCall',
          id: '39222ce9-f23e-4779-a54f-04336773b81f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Delete',
          id: 'fc413095-5550-4f7b-b593-8966db3651c1'
        },
        {
          englishName: 'CaseManagement.Cases.Pick',
          id: '4ff0b185-c87c-4cfe-b73b-7631b850ded2'
        },
        {
          englishName: 'PharmacyManagement.Drugs.ReadAll',
          id: 'ae0c99f8-a596-453c-a1fc-be9274226805'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Update',
          id: '47ba269e-c88b-4807-9c7c-3f08f8e6d5ae'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.AddDrug',
          id: 'a2ade989-7dd9-4e04-9f57-80069b0ff670'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.Read',
          id: 'ef4c4801-98ab-4e6b-a89e-9d5cc7c7428b'
        },
        {
          englishName: 'CaseManagement.Cases.Create',
          id: '3ff9d635-efb8-4a19-908e-a63cc80d9605'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.Read',
          id: 'e80e5b94-e43b-4a63-963c-62cd12bfe79e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Update',
          id: '9a7d9846-23f4-4fc7-a0dc-1f4c4d7372d2'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.Read',
          id: '29cb9146-e14f-4b22-a029-bd6039a667a4'
        },
        {
          englishName: 'PatientManagement.Allergies.Read',
          id: '4c1ff8dc-f9b5-4fcb-b474-a9888b14ae17'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Create',
          id: 'c70db49d-87d0-44ec-a4af-4a4daee16d1e'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.ReadAll',
          id: '2b002274-82a0-4657-994a-9ec3fa50413c'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Update',
          id: '124e91c6-b3b0-4377-ac51-787ad84faae5'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Delete',
          id: '72ea4ab9-be6f-42b5-b67b-1270f3aafa18'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Update',
          id: '866def7b-dd09-47e9-9108-affafba23536'
        },
        {
          englishName: 'CaseManagement.Cases.Delete',
          id: 'c1b3dd34-9f5c-456c-b7a3-1e91433ba64b'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.CaseMedicationsRecommendations.Read',
          id: 'a1d6c181-f28e-4339-b24c-2d5b2fbd74ef'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.Read',
          id: 'df441d01-d694-4012-be80-61e7b7b734b7'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Create',
          id: 'ca4cf8bd-cdb5-4a54-ad74-b6e83a711a7b'
        },
        {
          englishName: 'CaseManagement.Cases.Resolve',
          id: '437c9e2b-78e5-4d7d-a4e0-ae0cc8a5db6a'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Create',
          id: '5c75399d-0561-42ea-8f23-7b84c33385ca'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Delete',
          id: '09b2ae0c-4e94-44d3-8789-404c799dd98d'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Create',
          id: '2de25423-1b01-4a4f-aa64-2b33fcae3d9e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Update',
          id: '9716dc25-aff5-4354-9b47-261abf13cf70'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Read',
          id: '39ff901e-00db-4ba1-b323-ad2773fceaa4'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Create',
          id: '944f7c45-f2ad-402f-982f-c8787a1ae9b1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Create',
          id: '2320ece1-52b5-4b2f-8edc-6b9ebedae7b4'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Statistics',
          id: '36408604-3c19-4abe-8e91-f359f3b4f0e1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.RemoveAttachment',
          id: '95cc3296-7927-48af-a8d3-91dd269560db'
        },
        {
          englishName: 'PatientManagement.Diseases.Read',
          id: '8d226404-09f4-4932-9b0b-32bf2608af56'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.RemoveDrug',
          id: '5da3e2e4-ef08-4680-b153-a9ecaf03ffd2'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Read',
          id: '8f839465-15c6-46de-8b87-0418383d33eb'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.Read',
          id: '187005d5-9779-49ce-9607-9daa49245822'
        },
        {
          englishName: 'UtilityManagement.Attachments.Read',
          id: '860699e1-5f45-4ca9-9674-32b742b29b38'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.ReadAll',
          id: '107e4459-fce2-4368-a23f-de551285d68c'
        },
        {
          englishName: 'PatientManagement.Allergies.ReadAll',
          id: '7d46fca5-bd62-43c7-b053-57da68c7ace5'
        },
        {
          englishName: 'PatientManagement.Symptoms.ReadAll',
          id: '6b9b7295-6f5e-4e93-8f28-71991afbb90e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Delete',
          id: '86de5594-df7c-4819-b631-8fac13f12671'
        },
        {
          englishName: 'PatientManagement.Surgeries.Read',
          id: '843c8c89-4965-4778-b88d-b3ae698e308a'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Update',
          id: '4d231dcb-b6d7-47b1-9840-18d270269f1f'
        },
        {
          englishName: 'PatientManagement.XRays.ReadAll',
          id: 'bef27c7a-deed-492b-85eb-31eadeccd60d'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.ReadAll',
          id: '4daecd21-ed04-4efe-9556-f90d3a7e7820'
        },
        {
          englishName: 'PatientManagement.Symptoms.Read',
          id: '7d964f92-52a4-4bd7-be6d-2baa1cea9499'
        },
        {
          englishName: 'PatientManagement.XRays.Read',
          id: '77ff5753-3c54-4b8a-94e3-286d2ac9ebac'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.Read',
          id: '1f70f714-ded1-4735-908f-48af02bd5597'
        },
        {
          englishName: 'CaseManagement.Cases.AddAttachment',
          id: '318fe770-a6ae-41c7-9f08-7c7daf115b0f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Read',
          id: 'a16a8984-e124-47c2-a7c2-0e7d36391bae'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.Read',
          id: 'c4222ad7-8d31-4c6a-ab30-849263a93a1e'
        },
        {
          englishName: 'OrderManagement.Orders.Create',
          id: '15759108-47f8-4530-901e-0b61cc48c629'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.ReadAll',
          id: 'f406b7a6-a766-42d4-bc2d-f90d2b3b30a4'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Update',
          id: 'dd54fd3f-49c4-4603-9832-a78dcf09532d'
        }
      ],
      englishName: 'Children Doctor',
      id: '3858af59-9a3b-4d28-9c35-da909ba9a8f0'
    },
    {
      systemRole: {
        englishName: 'PoisonsDoctor',
        id: '0dab75fe-4ff1-49dd-bcf6-520fb47bad3f'
      },
      permissions: [
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Delete',
          id: '843b5d3d-1f6c-4bd0-ae48-906b62a7efec'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.ReadAll',
          id: 'c2c39be1-db3b-4970-9f3f-ab8bdeabebf1'
        },
        {
          englishName: 'SupplierManagement.Doctors.ReadAll',
          id: '0101e959-49a0-4b49-8daa-033a8f8bc9db'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Delete',
          id: '4b350527-9099-4bdf-a32a-51f98ef73ae7'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Read',
          id: 'e96ff4b4-939a-47b2-95e0-51219af7ccba'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Create',
          id: '5c75399d-0561-42ea-8f23-7b84c33385ca'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Create',
          id: '2de25423-1b01-4a4f-aa64-2b33fcae3d9e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.ReadAll',
          id: '5096afe7-b17f-465f-a844-25e8e6211c80'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Update',
          id: '9a7d9846-23f4-4fc7-a0dc-1f4c4d7372d2'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.XrayVisitRecommendations.Create',
          id: '481c8022-9b65-4cf6-9a7f-0702265bb83d'
        },
        {
          englishName: 'PatientManagement.Addictions.Read',
          id: '829f8641-a22c-4536-96b7-db3c19dd6278'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Update',
          id: '9716dc25-aff5-4354-9b47-261abf13cf70'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Delete',
          id: 'b18b6321-b32d-42e4-b244-dc5c681b37d4'
        },
        {
          englishName: 'PharmacyManagement.Drugs.Read',
          id: 'd56cb521-e375-4197-938c-63525fbb4ee8'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Delete',
          id: 'a736e0f8-02c3-4ab0-817a-b0219b44610a'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Read',
          id: 'e49a5772-ebd1-4d9a-ad68-48ea628f557c'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Statistics',
          id: '36408604-3c19-4abe-8e91-f359f3b4f0e1'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.ReadAll',
          id: '1c1ca879-9f80-4feb-bc5e-d098e714e240'
        },
        {
          englishName: 'CaseManagement.Cases.RemoveAttachment',
          id: '1c693900-35fd-47a2-b7a1-6a27c6da8817'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Update',
          id: '1cc31b62-c4fd-44d2-a338-e041f29d4af1'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.Read',
          id: '187005d5-9779-49ce-9607-9daa49245822'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Read',
          id: '948ccb6f-6575-4e4a-8061-a8dadb825436'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Read',
          id: '8f839465-15c6-46de-8b87-0418383d33eb'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Create',
          id: '7cad122b-7b6d-4293-a22e-0a8c87d8905f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.ReadAll',
          id: 'c1d36c28-d7b7-4ec6-83a5-53f41d560420'
        },
        {
          englishName: 'SupplierManagement.Doctors.Read',
          id: '49a0a23f-c48c-40fa-b21b-980ddce5f25e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.ReadAll',
          id: '80031ffc-3ade-4488-a7ae-5b00fc746137'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.CaseMedicationsRecommendations.Read',
          id: 'a1d6c181-f28e-4339-b24c-2d5b2fbd74ef'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Update',
          id: 'ed4b2f4a-b168-4247-836a-7045a580d8fe'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Read',
          id: 'a16a8984-e124-47c2-a7c2-0e7d36391bae'
        },
        {
          englishName: 'PharmacyManagement.Drugs.ReadAll',
          id: 'ae0c99f8-a596-453c-a1fc-be9274226805'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Create',
          id: 'b209e101-75bc-4685-863f-583cba497029'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.ReadAll',
          id: 'bd6033b1-a99b-4263-b553-98c1872802b1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Update',
          id: 'e22d2692-1071-4b1e-80d5-7394daec3e0b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.ReadAll',
          id: '5d32a82f-7d7b-42d7-a727-981a1388c7f7'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Read',
          id: 'e67f22ad-f8a7-4f8c-907d-c8a996f523e3'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Delete',
          id: '8b79e557-c32b-437c-bf2b-1f57f1c2b414'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Delete',
          id: '990d0f0f-0874-4486-a861-393fb97d3cc5'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Read',
          id: '383ce616-9b2a-48b2-b7d5-bea39c393ebf'
        },
        {
          englishName: 'CaseManagement.Cases.ReadAll',
          id: '82c4cb9d-b851-4a26-89d9-d3824051b555'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Delete',
          id: '09b2ae0c-4e94-44d3-8789-404c799dd98d'
        },
        {
          englishName: 'UtilityManagement.Attachments.Create',
          id: '5521ed9b-cd88-46c8-97fe-9fb6c17e6a53'
        },
        {
          englishName: 'OrderManagement.Orders.Create',
          id: '15759108-47f8-4530-901e-0b61cc48c629'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Update',
          id: '4d231dcb-b6d7-47b1-9840-18d270269f1f'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.Read',
          id: '29cb9146-e14f-4b22-a029-bd6039a667a4'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Read',
          id: '7f379288-803c-41ea-ad64-14a0a1b5eb7f'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.Read',
          id: 'c4222ad7-8d31-4c6a-ab30-849263a93a1e'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.InstructionsRecommendations.Create',
          id: '1ff38507-cc99-4442-8658-99dee989db51'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.ReadAll',
          id: 'a59653dd-778c-4f9a-a352-c5813df8cb8a'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.Read',
          id: '403f0c5b-e4bd-4b73-a000-f4c55527929e'
        },
        {
          englishName: 'PatientManagement.Surgeries.Read',
          id: '843c8c89-4965-4778-b88d-b3ae698e308a'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.LabVisitRecommendations.Create',
          id: 'f295bd7e-1630-49f1-9df6-25559d30df31'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Update',
          id: 'a1141730-ae52-4439-a331-000721f23d4a'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Update',
          id: 'dd54fd3f-49c4-4603-9832-a78dcf09532d'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.AddAttachment',
          id: '0652e56a-0450-42ce-a5e3-0bc152591000'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.ReadAll',
          id: '18ff90f3-79dc-4657-80f6-5d01a339d44e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.RemoveAttachment',
          id: '95cc3296-7927-48af-a8d3-91dd269560db'
        },
        {
          englishName: 'PatientManagement.Symptoms.Read',
          id: '7d964f92-52a4-4bd7-be6d-2baa1cea9499'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.ReadAll',
          id: 'df3cdc5e-5014-473f-a005-32ff03a8c2dc'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.AddDrug',
          id: 'a2ade989-7dd9-4e04-9f57-80069b0ff670'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.ReadAll',
          id: 'f406b7a6-a766-42d4-bc2d-f90d2b3b30a4'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.ReadAll',
          id: '07429ce9-64b7-471f-9ceb-cc0eed378527'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Update',
          id: '05318759-fc0e-43b3-80d1-4e676b94125f'
        },
        {
          englishName: 'CaseManagement.Cases.Read',
          id: '4907c9ab-0c55-4b87-97f4-7de4273597fb'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Create',
          id: '6a3c779f-fcb2-4e65-9dc3-48fcd5664491'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Delete',
          id: '72ea4ab9-be6f-42b5-b67b-1270f3aafa18'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.Read',
          id: 'e6699e20-74fa-4244-bb72-4cdcd8592bba'
        },
        {
          englishName: 'CaseManagement.Cases.Cancel',
          id: '312688cf-e00f-4c44-bd5a-8a9ad54c0c2d'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Delete',
          id: 'fc413095-5550-4f7b-b593-8966db3651c1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.ReadAll',
          id: '4cc35a8a-a9da-4661-981a-416ba469a9fb'
        },
        {
          englishName: 'PatientManagement.Addictions.ReadAll',
          id: '8a1d5947-eb2d-47bb-8f95-5a9bc0d2f3dc'
        },
        {
          englishName: 'CaseManagement.Cases.ReadCaseLookups',
          id: 'eacc1001-283a-4ae9-9d21-61dc5eac6ccb'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Update',
          id: '1b440cb3-4bb2-4c3c-9622-1d90e95f28a0'
        },
        {
          englishName: 'CaseManagement.Cases.AddAttachment',
          id: '318fe770-a6ae-41c7-9f08-7c7daf115b0f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Read',
          id: 'd9ecfe9e-f8e7-4af3-8529-c1d8352875f1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Create',
          id: 'c70db49d-87d0-44ec-a4af-4a4daee16d1e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Read',
          id: '1f0d0e89-7a8e-4e6c-b53d-ee9387f85544'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Update',
          id: '47ba269e-c88b-4807-9c7c-3f08f8e6d5ae'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.ReadAll',
          id: '107e4459-fce2-4368-a23f-de551285d68c'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Delete',
          id: '4bec520c-119b-4170-b2e2-af1b3ec8dd47'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.Read',
          id: 'e80e5b94-e43b-4a63-963c-62cd12bfe79e'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.ReadAll',
          id: '4daecd21-ed04-4efe-9556-f90d3a7e7820'
        },
        {
          englishName: 'SupplierManagement.Hospitals.ReadAll',
          id: '58d9bde5-8698-4dea-901b-532546f42744'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Delete',
          id: '9d38aec1-ad13-4082-8bb4-7ef5c5eb70a1'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.ReadAll',
          id: '4ac1190e-c666-45a3-a3fc-c9f9ac4d5582'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.ReadAll',
          id: '14c9ca3a-94a6-44d9-869f-147db13cf0e6'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Create',
          id: 'ca4cf8bd-cdb5-4a54-ad74-b6e83a711a7b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Create',
          id: 'f28d756e-72ab-4edc-88b0-705cbbc03b40'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.Read',
          id: 'ef4c4801-98ab-4e6b-a89e-9d5cc7c7428b'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Read',
          id: '84f5f633-f3a9-458a-9d4a-07c9853596e4'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.VisitHospitalRecommendations.Create',
          id: 'd95877a0-68fa-4eb8-aad7-2f5cdaf1d937'
        },
        {
          englishName: 'UtilityManagement.Attachments.Read',
          id: '860699e1-5f45-4ca9-9674-32b742b29b38'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.ReadAll',
          id: 'bcbd4efb-a055-46ab-bcb4-600cc9dea85d'
        },
        {
          englishName: 'PatientManagement.Allergies.ReadAll',
          id: '7d46fca5-bd62-43c7-b053-57da68c7ace5'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Create',
          id: '881f1c2e-44c0-4e95-bbed-56c98bfd4daf'
        },
        {
          englishName: 'CaseManagement.Cases.Create',
          id: '3ff9d635-efb8-4a19-908e-a63cc80d9605'
        },
        {
          englishName: 'CaseManagement.Cases.Delete',
          id: 'c1b3dd34-9f5c-456c-b7a3-1e91433ba64b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Create',
          id: 'a254e5a6-b572-4ea2-b943-fc372cd84012'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Create',
          id: '944f7c45-f2ad-402f-982f-c8787a1ae9b1'
        },
        {
          englishName: 'CaseManagement.Cases.StartCall',
          id: '39222ce9-f23e-4779-a54f-04336773b81f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Delete',
          id: '86de5594-df7c-4819-b631-8fac13f12671'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Create',
          id: '2320ece1-52b5-4b2f-8edc-6b9ebedae7b4'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.Read',
          id: '25d09104-34ce-441c-a63e-e41fe35ab609'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.ReadAll',
          id: '9766fb16-a221-4ad8-b1c5-61d12c4edcc3'
        },
        {
          englishName: 'PatientManagement.XRays.Read',
          id: '77ff5753-3c54-4b8a-94e3-286d2ac9ebac'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Read',
          id: '39ff901e-00db-4ba1-b323-ad2773fceaa4'
        },
        {
          englishName: 'PatientManagement.Allergies.Read',
          id: '4c1ff8dc-f9b5-4fcb-b474-a9888b14ae17'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientRelatedProfiles.Create',
          id: 'fac4b038-a649-4f9c-a914-7cba155eb86c'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.ReadAll',
          id: '6cee56f8-3795-4981-ba6e-e8b6d7500c52'
        },
        {
          englishName: 'CaseManagement.Cases.ReadMyCases',
          id: '0a607daa-c85e-4461-bddc-fb9ed0b091ad'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.ReadAll',
          id: '2b002274-82a0-4657-994a-9ec3fa50413c'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.Delete',
          id: '484b462d-7cb0-4025-a270-208d69548ab5'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Update',
          id: '124e91c6-b3b0-4377-ac51-787ad84faae5'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.RemoveDrug',
          id: '5da3e2e4-ef08-4680-b153-a9ecaf03ffd2'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Create',
          id: 'ecb1a75b-9f74-4fca-b3d7-9cdde4c2c16d'
        },
        {
          englishName: 'PatientManagement.Diseases.Read',
          id: '8d226404-09f4-4932-9b0b-32bf2608af56'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Create',
          id: 'd6e3bd9a-4f2f-4ed7-83e2-465ee70baab6'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.VisitSpecializedDoctorRecommendations.Create',
          id: '17a6c269-8635-4e83-b0c2-5c8a71913161'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Delete',
          id: '8c85a1e5-ac7c-43c4-858c-70f90465707b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.ReadAll',
          id: '205015ea-eeee-46aa-b036-fa954d27d253'
        },
        {
          englishName: 'PatientManagement.Symptoms.ReadAll',
          id: '6b9b7295-6f5e-4e93-8f28-71991afbb90e'
        },
        {
          englishName: 'PatientManagement.Surgeries.ReadAll',
          id: 'a41c9af2-eb63-4e9a-a357-ca9c0db6852c'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Delete',
          id: 'a6173827-c86c-4961-9cff-b999bc5b93c5'
        },
        {
          englishName: 'PatientManagement.Diseases.ReadAll',
          id: '5d573f0e-dea3-4061-9097-ad48e068d934'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientRelatedProfiles.ReadAll',
          id: 'ad520aba-8632-42ff-b5a6-aa472d658315'
        },
        {
          englishName: 'CaseManagement.Cases.Resolve',
          id: '437c9e2b-78e5-4d7d-a4e0-ae0cc8a5db6a'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.Read',
          id: 'df441d01-d694-4012-be80-61e7b7b734b7'
        },
        {
          englishName: 'CaseManagement.Cases.EndCall',
          id: '2589fdc1-e717-469c-b8e9-026102c9be3a'
        },
        {
          englishName: 'SupplierManagement.Hospitals.Read',
          id: 'eb368ee7-2dee-41a3-8cef-3995d9f577e7'
        },
        {
          englishName: 'CaseManagement.Cases.Update',
          id: 'fd4b45c6-8395-4cd0-a61d-0b415c598941'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.Read',
          id: '1f70f714-ded1-4735-908f-48af02bd5597'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Read',
          id: 'c84c8f43-8fc0-4d65-8303-e3e805f783d3'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Update',
          id: '5c210591-3a81-4f8a-8a52-10ee16bf6f13'
        },
        {
          englishName: 'PatientManagement.XRays.ReadAll',
          id: 'bef27c7a-deed-492b-85eb-31eadeccd60d'
        },
        {
          englishName: 'CaseManagement.Cases.Pick',
          id: '4ff0b185-c87c-4cfe-b73b-7631b850ded2'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.ReadAll',
          id: '6056fc19-8812-4701-92d7-b424da47db82'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Update',
          id: '866def7b-dd09-47e9-9108-affafba23536'
        }
      ],
      englishName: 'Poisons Doctor',
      id: '54ffb014-b445-44b6-829a-7022a59b5883'
    },
    {
      systemRole: {
        englishName: 'GeneralPractitionerDoctor',
        id: 'a0d3f567-16a0-4d08-978c-86418e621125'
      },
      permissions: [
        {
          englishName: 'PatientManagement.XRays.XRayCategories.Read',
          id: '29cb9146-e14f-4b22-a029-bd6039a667a4'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Create',
          id: '2de25423-1b01-4a4f-aa64-2b33fcae3d9e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Read',
          id: 'e67f22ad-f8a7-4f8c-907d-c8a996f523e3'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Update',
          id: '124e91c6-b3b0-4377-ac51-787ad84faae5'
        },
        {
          englishName: 'CaseManagement.Cases.Create',
          id: '3ff9d635-efb8-4a19-908e-a63cc80d9605'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Update',
          id: '9a7d9846-23f4-4fc7-a0dc-1f4c4d7372d2'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Read',
          id: '39ff901e-00db-4ba1-b323-ad2773fceaa4'
        },
        {
          englishName: 'CaseManagement.Cases.EndCall',
          id: '2589fdc1-e717-469c-b8e9-026102c9be3a'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Delete',
          id: 'b18b6321-b32d-42e4-b244-dc5c681b37d4'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.Delete',
          id: '484b462d-7cb0-4025-a270-208d69548ab5'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.Read',
          id: 'c4222ad7-8d31-4c6a-ab30-849263a93a1e'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.ReadAll',
          id: 'f406b7a6-a766-42d4-bc2d-f90d2b3b30a4'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Update',
          id: '866def7b-dd09-47e9-9108-affafba23536'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Delete',
          id: '8c85a1e5-ac7c-43c4-858c-70f90465707b'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Read',
          id: '84f5f633-f3a9-458a-9d4a-07c9853596e4'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Create',
          id: '881f1c2e-44c0-4e95-bbed-56c98bfd4daf'
        },
        {
          englishName: 'PatientManagement.XRays.Read',
          id: '77ff5753-3c54-4b8a-94e3-286d2ac9ebac'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Delete',
          id: 'a6173827-c86c-4961-9cff-b999bc5b93c5'
        },
        {
          englishName: 'CaseManagement.Cases.ReadMyCases',
          id: '0a607daa-c85e-4461-bddc-fb9ed0b091ad'
        },
        {
          englishName: 'PatientManagement.Surgeries.ReadAll',
          id: 'a41c9af2-eb63-4e9a-a357-ca9c0db6852c'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientRelatedProfiles.Create',
          id: 'fac4b038-a649-4f9c-a914-7cba155eb86c'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Read',
          id: '1f0d0e89-7a8e-4e6c-b53d-ee9387f85544'
        },
        {
          englishName: 'SupplierManagement.Hospitals.Read',
          id: 'eb368ee7-2dee-41a3-8cef-3995d9f577e7'
        },
        {
          englishName: 'CaseManagement.Cases.Delete',
          id: 'c1b3dd34-9f5c-456c-b7a3-1e91433ba64b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Update',
          id: '1cc31b62-c4fd-44d2-a338-e041f29d4af1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Create',
          id: 'a254e5a6-b572-4ea2-b943-fc372cd84012'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Create',
          id: 'b209e101-75bc-4685-863f-583cba497029'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Update',
          id: '05318759-fc0e-43b3-80d1-4e676b94125f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Delete',
          id: '4b350527-9099-4bdf-a32a-51f98ef73ae7'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.Read',
          id: '403f0c5b-e4bd-4b73-a000-f4c55527929e'
        },
        {
          englishName: 'PatientManagement.Addictions.Read',
          id: '829f8641-a22c-4536-96b7-db3c19dd6278'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Update',
          id: '5c210591-3a81-4f8a-8a52-10ee16bf6f13'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.ReadAll',
          id: '18ff90f3-79dc-4657-80f6-5d01a339d44e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Update',
          id: '9716dc25-aff5-4354-9b47-261abf13cf70'
        },
        {
          englishName: 'PatientManagement.Diseases.Read',
          id: '8d226404-09f4-4932-9b0b-32bf2608af56'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Delete',
          id: '4bec520c-119b-4170-b2e2-af1b3ec8dd47'
        },
        {
          englishName: 'CaseManagement.Cases.Cancel',
          id: '312688cf-e00f-4c44-bd5a-8a9ad54c0c2d'
        },
        {
          englishName: 'CaseManagement.Cases.RemoveAttachment',
          id: '1c693900-35fd-47a2-b7a1-6a27c6da8817'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Create',
          id: 'f28d756e-72ab-4edc-88b0-705cbbc03b40'
        },
        {
          englishName: 'CaseManagement.Cases.Update',
          id: 'fd4b45c6-8395-4cd0-a61d-0b415c598941'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Read',
          id: '8f839465-15c6-46de-8b87-0418383d33eb'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Delete',
          id: '09b2ae0c-4e94-44d3-8789-404c799dd98d'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Read',
          id: 'c84c8f43-8fc0-4d65-8303-e3e805f783d3'
        },
        {
          englishName: 'SupplierManagement.Doctors.Read',
          id: '49a0a23f-c48c-40fa-b21b-980ddce5f25e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientRelatedProfiles.ReadAll',
          id: 'ad520aba-8632-42ff-b5a6-aa472d658315'
        },
        {
          englishName: 'OrderManagement.Orders.Create',
          id: '15759108-47f8-4530-901e-0b61cc48c629'
        },
        {
          englishName: 'CaseManagement.Cases.Resolve',
          id: '437c9e2b-78e5-4d7d-a4e0-ae0cc8a5db6a'
        },
        {
          englishName: 'PatientManagement.Allergies.AllergyCategories.Read',
          id: '1f70f714-ded1-4735-908f-48af02bd5597'
        },
        {
          englishName: 'CaseManagement.Cases.StartCall',
          id: '39222ce9-f23e-4779-a54f-04336773b81f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Update',
          id: '47ba269e-c88b-4807-9c7c-3f08f8e6d5ae'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Update',
          id: 'ed4b2f4a-b168-4247-836a-7045a580d8fe'
        },
        {
          englishName: 'SupplierManagement.Doctors.ReadAll',
          id: '0101e959-49a0-4b49-8daa-033a8f8bc9db'
        },
        {
          englishName: 'CaseManagement.Cases.ReadAll',
          id: '82c4cb9d-b851-4a26-89d9-d3824051b555'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.VisitHospitalRecommendations.Create',
          id: 'd95877a0-68fa-4eb8-aad7-2f5cdaf1d937'
        },
        {
          englishName: 'PharmacyManagement.Drugs.Read',
          id: 'd56cb521-e375-4197-938c-63525fbb4ee8'
        },
        {
          englishName: 'PatientManagement.Allergies.ReadAll',
          id: '7d46fca5-bd62-43c7-b053-57da68c7ace5'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.ReadAll',
          id: '5d32a82f-7d7b-42d7-a727-981a1388c7f7'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Read',
          id: '7f379288-803c-41ea-ad64-14a0a1b5eb7f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Create',
          id: 'c70db49d-87d0-44ec-a4af-4a4daee16d1e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Delete',
          id: '990d0f0f-0874-4486-a861-393fb97d3cc5'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.CaseMedicationsRecommendations.Read',
          id: 'a1d6c181-f28e-4339-b24c-2d5b2fbd74ef'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.Read',
          id: '187005d5-9779-49ce-9607-9daa49245822'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Read',
          id: 'e49a5772-ebd1-4d9a-ad68-48ea628f557c'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.ReadAll',
          id: '5096afe7-b17f-465f-a844-25e8e6211c80'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.ReadAll',
          id: '9766fb16-a221-4ad8-b1c5-61d12c4edcc3'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.ReadAll',
          id: '80031ffc-3ade-4488-a7ae-5b00fc746137'
        },
        {
          englishName: 'CaseManagement.Cases.AddAttachment',
          id: '318fe770-a6ae-41c7-9f08-7c7daf115b0f'
        },
        {
          englishName: 'PharmacyManagement.Pharmacies.ReadAll',
          id: '4daecd21-ed04-4efe-9556-f90d3a7e7820'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Create',
          id: '6a3c779f-fcb2-4e65-9dc3-48fcd5664491'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.ReadAll',
          id: 'bd6033b1-a99b-4263-b553-98c1872802b1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Delete',
          id: '72ea4ab9-be6f-42b5-b67b-1270f3aafa18'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Update',
          id: '1b440cb3-4bb2-4c3c-9622-1d90e95f28a0'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Delete',
          id: '9d38aec1-ad13-4082-8bb4-7ef5c5eb70a1'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.ReadAll',
          id: '1c1ca879-9f80-4feb-bc5e-d098e714e240'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Read',
          id: 'd9ecfe9e-f8e7-4af3-8529-c1d8352875f1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Read',
          id: '948ccb6f-6575-4e4a-8061-a8dadb825436'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Delete',
          id: '8b79e557-c32b-437c-bf2b-1f57f1c2b414'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Create',
          id: 'ecb1a75b-9f74-4fca-b3d7-9cdde4c2c16d'
        },
        {
          englishName: 'PatientManagement.XRays.XRayCategories.ReadAll',
          id: '2b002274-82a0-4657-994a-9ec3fa50413c'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.ReadAll',
          id: 'c1d36c28-d7b7-4ec6-83a5-53f41d560420'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Create',
          id: 'ca4cf8bd-cdb5-4a54-ad74-b6e83a711a7b'
        },
        {
          englishName: 'PharmacyManagement.Drugs.ReadAll',
          id: 'ae0c99f8-a596-453c-a1fc-be9274226805'
        },
        {
          englishName: 'UtilityManagement.Attachments.Create',
          id: '5521ed9b-cd88-46c8-97fe-9fb6c17e6a53'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Statistics',
          id: '36408604-3c19-4abe-8e91-f359f3b4f0e1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Update',
          id: 'a1141730-ae52-4439-a331-000721f23d4a'
        },
        {
          englishName: 'CaseManagement.Cases.ReadCaseLookups',
          id: 'eacc1001-283a-4ae9-9d21-61dc5eac6ccb'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.AddAttachment',
          id: '0652e56a-0450-42ce-a5e3-0bc152591000'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Update',
          id: 'dd54fd3f-49c4-4603-9832-a78dcf09532d'
        },
        {
          englishName: 'SupplierManagement.LabAnalysisCenters.ReadAll',
          id: '107e4459-fce2-4368-a23f-de551285d68c'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Update',
          id: '4d231dcb-b6d7-47b1-9840-18d270269f1f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.ReadAll',
          id: '4cc35a8a-a9da-4661-981a-416ba469a9fb'
        },
        {
          englishName: 'PatientManagement.Allergies.Read',
          id: '4c1ff8dc-f9b5-4fcb-b474-a9888b14ae17'
        },
        {
          englishName: 'PatientManagement.Symptoms.ReadAll',
          id: '6b9b7295-6f5e-4e93-8f28-71991afbb90e'
        },
        {
          englishName: 'PatientManagement.Addictions.ReadAll',
          id: '8a1d5947-eb2d-47bb-8f95-5a9bc0d2f3dc'
        },
        {
          englishName: 'CaseManagement.Cases.Pick',
          id: '4ff0b185-c87c-4cfe-b73b-7631b850ded2'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Read',
          id: 'e96ff4b4-939a-47b2-95e0-51219af7ccba'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Delete',
          id: 'a736e0f8-02c3-4ab0-817a-b0219b44610a'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.VisitSpecializedDoctorRecommendations.Create',
          id: '17a6c269-8635-4e83-b0c2-5c8a71913161'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.ReadAll',
          id: 'a59653dd-778c-4f9a-a352-c5813df8cb8a'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.ReadAll',
          id: 'df3cdc5e-5014-473f-a005-32ff03a8c2dc'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Update',
          id: 'e22d2692-1071-4b1e-80d5-7394daec3e0b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.ReadAll',
          id: 'bcbd4efb-a055-46ab-bcb4-600cc9dea85d'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Create',
          id: '2320ece1-52b5-4b2f-8edc-6b9ebedae7b4'
        },
        {
          englishName: 'PatientManagement.Diseases.DiseaseCategories.Read',
          id: '25d09104-34ce-441c-a63e-e41fe35ab609'
        },
        {
          englishName: 'SupplierManagement.Hospitals.ReadAll',
          id: '58d9bde5-8698-4dea-901b-532546f42744'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.ReadAll',
          id: '6cee56f8-3795-4981-ba6e-e8b6d7500c52'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Create',
          id: '5c75399d-0561-42ea-8f23-7b84c33385ca'
        },
        {
          englishName: 'PatientManagement.Diseases.ReadAll',
          id: '5d573f0e-dea3-4061-9097-ad48e068d934'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.ReadAll',
          id: '6056fc19-8812-4701-92d7-b424da47db82'
        },
        {
          englishName: 'CaseManagement.Cases.Read',
          id: '4907c9ab-0c55-4b87-97f4-7de4273597fb'
        },
        {
          englishName: 'PatientManagement.Symptoms.SymptomCategories.ReadAll',
          id: '4ac1190e-c666-45a3-a3fc-c9f9ac4d5582'
        },
        {
          englishName: 'SupplierManagement.XrayCenters.Read',
          id: 'e80e5b94-e43b-4a63-963c-62cd12bfe79e'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.Read',
          id: 'ef4c4801-98ab-4e6b-a89e-9d5cc7c7428b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Delete',
          id: '843b5d3d-1f6c-4bd0-ae48-906b62a7efec'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Delete',
          id: 'fc413095-5550-4f7b-b593-8966db3651c1'
        },
        {
          englishName: 'PatientManagement.LabAnalyses.Read',
          id: 'e6699e20-74fa-4244-bb72-4cdcd8592bba'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.RemoveDrug',
          id: '5da3e2e4-ef08-4680-b153-a9ecaf03ffd2'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Delete',
          id: '86de5594-df7c-4819-b631-8fac13f12671'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.InstructionsRecommendations.Create',
          id: '1ff38507-cc99-4442-8658-99dee989db51'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.LabVisitRecommendations.Create',
          id: 'f295bd7e-1630-49f1-9df6-25559d30df31'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.ReadAll',
          id: '07429ce9-64b7-471f-9ceb-cc0eed378527'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Read',
          id: 'a16a8984-e124-47c2-a7c2-0e7d36391bae'
        },
        {
          englishName: 'UtilityManagement.Attachments.Read',
          id: '860699e1-5f45-4ca9-9674-32b742b29b38'
        },
        {
          englishName: 'PatientManagement.Surgeries.Read',
          id: '843c8c89-4965-4778-b88d-b3ae698e308a'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.XrayVisitRecommendations.Create',
          id: '481c8022-9b65-4cf6-9a7f-0702265bb83d'
        },
        {
          englishName: 'PatientManagement.Symptoms.Read',
          id: '7d964f92-52a4-4bd7-be6d-2baa1cea9499'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.ReadAll',
          id: '205015ea-eeee-46aa-b036-fa954d27d253'
        },
        {
          englishName: 'PatientManagement.XRays.ReadAll',
          id: 'bef27c7a-deed-492b-85eb-31eadeccd60d'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.RemoveAttachment',
          id: '95cc3296-7927-48af-a8d3-91dd269560db'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.ReadAll',
          id: '14c9ca3a-94a6-44d9-869f-147db13cf0e6'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.AddDrug',
          id: 'a2ade989-7dd9-4e04-9f57-80069b0ff670'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Read',
          id: '383ce616-9b2a-48b2-b7d5-bea39c393ebf'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Create',
          id: 'd6e3bd9a-4f2f-4ed7-83e2-465ee70baab6'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Create',
          id: '944f7c45-f2ad-402f-982f-c8787a1ae9b1'
        },
        {
          englishName: 'PatientManagement.Surgeries.SurgeryCategories.ReadAll',
          id: 'c2c39be1-db3b-4970-9f3f-ab8bdeabebf1'
        },
        {
          englishName: 'PatientManagement.Addictions.AddictionCategories.Read',
          id: 'df441d01-d694-4012-be80-61e7b7b734b7'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Create',
          id: '7cad122b-7b6d-4293-a22e-0a8c87d8905f'
        }
      ],
      englishName: 'GP Doctor',
      id: '46e13951-3f02-46c9-ba18-2c57d1c76e11'
    },
    {
      permissions: [
        {
          englishName: 'CaseManagement.Cases.StartCall',
          id: '39222ce9-f23e-4779-a54f-04336773b81f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.RemoveDrug',
          id: '5da3e2e4-ef08-4680-b153-a9ecaf03ffd2'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.ReadAll',
          id: '9766fb16-a221-4ad8-b1c5-61d12c4edcc3'
        },
        {
          englishName: 'CaseManagement.Cases.Resolve',
          id: '437c9e2b-78e5-4d7d-a4e0-ae0cc8a5db6a'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Update',
          id: '9716dc25-aff5-4354-9b47-261abf13cf70'
        },
        {
          englishName: 'CaseManagement.Cases.Read',
          id: '4907c9ab-0c55-4b87-97f4-7de4273597fb'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.ReadAll',
          id: '4cc35a8a-a9da-4661-981a-416ba469a9fb'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Delete',
          id: '09b2ae0c-4e94-44d3-8789-404c799dd98d'
        },
        {
          englishName: 'CaseManagement.Cases.Pick',
          id: '4ff0b185-c87c-4cfe-b73b-7631b850ded2'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Create',
          id: 'ecb1a75b-9f74-4fca-b3d7-9cdde4c2c16d'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Create',
          id: '7cad122b-7b6d-4293-a22e-0a8c87d8905f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Read',
          id: 'e49a5772-ebd1-4d9a-ad68-48ea628f557c'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Read',
          id: 'a16a8984-e124-47c2-a7c2-0e7d36391bae'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Update',
          id: 'a1141730-ae52-4439-a331-000721f23d4a'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Statistics',
          id: '36408604-3c19-4abe-8e91-f359f3b4f0e1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Delete',
          id: 'a6173827-c86c-4961-9cff-b999bc5b93c5'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.InstructionsRecommendations.Create',
          id: '1ff38507-cc99-4442-8658-99dee989db51'
        },
        {
          englishName: 'CaseManagement.Cases.Delete',
          id: 'c1b3dd34-9f5c-456c-b7a3-1e91433ba64b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Delete',
          id: '843b5d3d-1f6c-4bd0-ae48-906b62a7efec'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.VisitHospitalRecommendations.Create',
          id: 'd95877a0-68fa-4eb8-aad7-2f5cdaf1d937'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Delete',
          id: '8c85a1e5-ac7c-43c4-858c-70f90465707b'
        },
        {
          englishName: 'UtilityManagement.Attachments.Read',
          id: '860699e1-5f45-4ca9-9674-32b742b29b38'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.ReadAll',
          id: '07429ce9-64b7-471f-9ceb-cc0eed378527'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Read',
          id: '39ff901e-00db-4ba1-b323-ad2773fceaa4'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Delete',
          id: '4b350527-9099-4bdf-a32a-51f98ef73ae7'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Create',
          id: '881f1c2e-44c0-4e95-bbed-56c98bfd4daf'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Create',
          id: '2de25423-1b01-4a4f-aa64-2b33fcae3d9e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Create',
          id: 'ca4cf8bd-cdb5-4a54-ad74-b6e83a711a7b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Update',
          id: '1cc31b62-c4fd-44d2-a338-e041f29d4af1'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.XrayVisitRecommendations.Create',
          id: '481c8022-9b65-4cf6-9a7f-0702265bb83d'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Delete',
          id: '9d38aec1-ad13-4082-8bb4-7ef5c5eb70a1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Update',
          id: 'ed4b2f4a-b168-4247-836a-7045a580d8fe'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Update',
          id: '05318759-fc0e-43b3-80d1-4e676b94125f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Read',
          id: '1f0d0e89-7a8e-4e6c-b53d-ee9387f85544'
        },
        {
          englishName: 'OrderManagement.Orders.Create',
          id: '15759108-47f8-4530-901e-0b61cc48c629'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.RemoveAttachment',
          id: '95cc3296-7927-48af-a8d3-91dd269560db'
        },
        {
          englishName: 'CaseManagement.Cases.EndCall',
          id: '2589fdc1-e717-469c-b8e9-026102c9be3a'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Update',
          id: '47ba269e-c88b-4807-9c7c-3f08f8e6d5ae'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.Read',
          id: '383ce616-9b2a-48b2-b7d5-bea39c393ebf'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Create',
          id: '5c75399d-0561-42ea-8f23-7b84c33385ca'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Create',
          id: '6a3c779f-fcb2-4e65-9dc3-48fcd5664491'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Read',
          id: '8f839465-15c6-46de-8b87-0418383d33eb'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientRelatedProfiles.Create',
          id: 'fac4b038-a649-4f9c-a914-7cba155eb86c'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Create',
          id: 'd6e3bd9a-4f2f-4ed7-83e2-465ee70baab6'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Read',
          id: '948ccb6f-6575-4e4a-8061-a8dadb825436'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.Delete',
          id: '484b462d-7cb0-4025-a270-208d69548ab5'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Update',
          id: '5c210591-3a81-4f8a-8a52-10ee16bf6f13'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Delete',
          id: '8b79e557-c32b-437c-bf2b-1f57f1c2b414'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Create',
          id: '944f7c45-f2ad-402f-982f-c8787a1ae9b1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.ReadAll',
          id: '5096afe7-b17f-465f-a844-25e8e6211c80'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Update',
          id: 'e22d2692-1071-4b1e-80d5-7394daec3e0b'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Update',
          id: '866def7b-dd09-47e9-9108-affafba23536'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Delete',
          id: '72ea4ab9-be6f-42b5-b67b-1270f3aafa18'
        },
        {
          englishName: 'UtilityManagement.Attachments.Create',
          id: '5521ed9b-cd88-46c8-97fe-9fb6c17e6a53'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Delete',
          id: 'a736e0f8-02c3-4ab0-817a-b0219b44610a'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.AddDrug',
          id: 'a2ade989-7dd9-4e04-9f57-80069b0ff670'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.ReadAll',
          id: '14c9ca3a-94a6-44d9-869f-147db13cf0e6'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Update',
          id: '4d231dcb-b6d7-47b1-9840-18d270269f1f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Delete',
          id: 'b18b6321-b32d-42e4-b244-dc5c681b37d4'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.ReadAll',
          id: '205015ea-eeee-46aa-b036-fa954d27d253'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.ReadAll',
          id: '80031ffc-3ade-4488-a7ae-5b00fc746137'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Delete',
          id: 'fc413095-5550-4f7b-b593-8966db3651c1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Create',
          id: '2320ece1-52b5-4b2f-8edc-6b9ebedae7b4'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Delete',
          id: '86de5594-df7c-4819-b631-8fac13f12671'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Update',
          id: 'dd54fd3f-49c4-4603-9832-a78dcf09532d'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.VisitSpecializedDoctorRecommendations.Create',
          id: '17a6c269-8635-4e83-b0c2-5c8a71913161'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientRelatedProfiles.ReadAll',
          id: 'ad520aba-8632-42ff-b5a6-aa472d658315'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Delete',
          id: '4bec520c-119b-4170-b2e2-af1b3ec8dd47'
        },
        {
          englishName: 'CaseManagement.Cases.ReadMyCases',
          id: '0a607daa-c85e-4461-bddc-fb9ed0b091ad'
        },
        {
          englishName: 'CaseManagement.Cases.ReadAll',
          id: '82c4cb9d-b851-4a26-89d9-d3824051b555'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.AddAttachment',
          id: '0652e56a-0450-42ce-a5e3-0bc152591000'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Read',
          id: '7f379288-803c-41ea-ad64-14a0a1b5eb7f'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Read',
          id: 'e67f22ad-f8a7-4f8c-907d-c8a996f523e3'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.LabVisitRecommendations.Create',
          id: 'f295bd7e-1630-49f1-9df6-25559d30df31'
        },
        {
          englishName: 'CaseManagement.Cases.Update',
          id: 'fd4b45c6-8395-4cd0-a61d-0b415c598941'
        },
        {
          englishName: 'CaseManagement.Cases.ReadCaseLookups',
          id: 'eacc1001-283a-4ae9-9d21-61dc5eac6ccb'
        },
        {
          englishName: 'CaseManagement.Cases.RemoveAttachment',
          id: '1c693900-35fd-47a2-b7a1-6a27c6da8817'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Delete',
          id: '990d0f0f-0874-4486-a861-393fb97d3cc5'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.ReadAll',
          id: 'c1d36c28-d7b7-4ec6-83a5-53f41d560420'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Create',
          id: 'b209e101-75bc-4685-863f-583cba497029'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Update',
          id: '1b440cb3-4bb2-4c3c-9622-1d90e95f28a0'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Create',
          id: 'f28d756e-72ab-4edc-88b0-705cbbc03b40'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Create',
          id: 'a254e5a6-b572-4ea2-b943-fc372cd84012'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.ReadAll',
          id: 'a59653dd-778c-4f9a-a352-c5813df8cb8a'
        },
        {
          englishName: 'CaseManagement.Cases.AddAttachment',
          id: '318fe770-a6ae-41c7-9f08-7c7daf115b0f'
        },
        {
          englishName: 'CaseManagement.Cases.Create',
          id: '3ff9d635-efb8-4a19-908e-a63cc80d9605'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Read',
          id: 'e96ff4b4-939a-47b2-95e0-51219af7ccba'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Create',
          id: 'c70db49d-87d0-44ec-a4af-4a4daee16d1e'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Read',
          id: 'd9ecfe9e-f8e7-4af3-8529-c1d8352875f1'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Update',
          id: '9a7d9846-23f4-4fc7-a0dc-1f4c4d7372d2'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientDiseases.ReadAll',
          id: 'bcbd4efb-a055-46ab-bcb4-600cc9dea85d'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Read',
          id: 'c84c8f43-8fc0-4d65-8303-e3e805f783d3'
        },
        {
          englishName: 'CaseManagement.CaseRecommendations.CaseMedicationsRecommendations.Read',
          id: 'a1d6c181-f28e-4339-b24c-2d5b2fbd74ef'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Update',
          id: '124e91c6-b3b0-4377-ac51-787ad84faae5'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.PatientAllergies.ReadAll',
          id: 'df3cdc5e-5014-473f-a005-32ff03a8c2dc'
        },
        {
          englishName: 'CaseManagement.Cases.Cancel',
          id: '312688cf-e00f-4c44-bd5a-8a9ad54c0c2d'
        },
        {
          englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.ReadAll',
          id: '5d32a82f-7d7b-42d7-a727-981a1388c7f7'
        }
      ],
      englishName: 'Doctor',
      id: '54ff3207-9267-4b9d-90dc-c7d76567a9a6'
    }
  ],
  paginationMetadata: {
    totalItemCount: 6,
    numberOfPages: 1,
    pageSize: 100,
    order: 'Ascending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

const specialziedRole: ISpecializedRoleResponse = {
  systemRole: {
    englishName: 'Administrator',
    id: '15ba0880-2438-4f30-8d65-17bd3374bec1'
  },
  permissions: [
    {
      englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Create',
      id: '4d51562a-9365-455c-94a1-be412dda14e4'
    },
    {
      englishName: 'PharmacyManagement.Drugs.Update',
      id: '0edd86a8-9ffb-46ab-a171-dca191192a57'
    },
    {
      englishName: 'PatientManagement.Symptoms.AddDrug',
      id: 'da300683-8cfb-439b-afe8-2a21049710d0'
    },
    {
      englishName: 'PharmacyManagement.Drugs.ReadAll',
      id: 'ae0c99f8-a596-453c-a1fc-be9274226805'
    },
    {
      englishName: 'PatientManagement.Symptoms.ReadAll',
      id: '6b9b7295-6f5e-4e93-8f28-71991afbb90e'
    },
    {
      englishName: 'PharmacyManagement.Pharmacies.Activate',
      id: '815fc778-a4f4-4f5f-b1f3-2f070bd61c4a'
    },
    {
      englishName: 'PatientManagement.Diseases.Create',
      id: 'e210c609-467b-492b-9632-37c6cdd9b125'
    },
    {
      englishName: 'PatientManagement.Surgeries.SurgeryCategories.Activate',
      id: '617764db-be81-4bd3-b6c8-f9bbccdef5c3'
    },
    {
      englishName: 'PatientManagement.Diseases.DiseaseCategories.Activate',
      id: '0f90b32a-c44d-4d1c-82b3-83030dfa8290'
    },
    {
      englishName: 'PatientManagement.Addictions.AddictionCategories.Create',
      id: '716f8191-c53a-4793-8666-0e9e1fecbdf9'
    },
    {
      englishName: 'PatientManagement.XRays.DeActivate',
      id: '133c73ca-5c71-465c-b047-465577c414f3'
    },
    {
      englishName: 'SupplierManagement.Hospitals.Activate',
      id: 'd096403c-5cbc-4d62-9f4c-cd1c35441316'
    },
    {
      englishName: 'PatientManagement.Surgeries.Import',
      id: '8bb968c1-c29e-40ea-8c08-9c870697b033'
    },
    {
      englishName: 'PatientManagement.Allergies.AllergyCategories.Update',
      id: 'dd961ebc-5ac7-41f3-b045-cbd531ec4482'
    },
    {
      englishName: 'SupplierManagement.LabAnalysisCenters.Read',
      id: '403f0c5b-e4bd-4b73-a000-f4c55527929e'
    },
    {
      englishName: 'PatientManagement.Surgeries.ReadAll',
      id: 'a41c9af2-eb63-4e9a-a357-ca9c0db6852c'
    },
    {
      englishName: 'PharmacyManagement.Pharmacies.Update',
      id: 'd95f964d-6979-40bd-89a5-78d4d13582f1'
    },
    {
      englishName: 'SupplierManagement.LabAnalysisCenters.Create',
      id: '20438ba8-0793-4da1-8928-5ca6eac10484'
    },
    {
      englishName: 'PharmacyManagement.Pharmacies.Read',
      id: '187005d5-9779-49ce-9607-9daa49245822'
    },
    {
      englishName: 'SupplierManagement.XrayCenters.ReadAll',
      id: 'f406b7a6-a766-42d4-bc2d-f90d2b3b30a4'
    },
    {
      englishName: 'PatientManagement.Diseases.DiseaseCategories.Update',
      id: '7ccf621f-7111-4f73-b336-94e76f20db00'
    },
    {
      englishName: 'PatientManagement.Diseases.DiseaseCategories.ReadAll',
      id: '1c1ca879-9f80-4feb-bc5e-d098e714e240'
    },
    {
      englishName: 'SupplierManagement.XrayCenters.Activate',
      id: 'c981bc27-bf86-49a5-9fba-25a614c72fa4'
    },
    {
      englishName: 'SupplierManagement.Doctors.DeActivate',
      id: 'c53f1421-bfd3-4378-959b-9c29e8ad9fae'
    },
    {
      englishName: 'PatientManagement.XRays.ReadAll',
      id: 'bef27c7a-deed-492b-85eb-31eadeccd60d'
    },
    {
      englishName: 'PatientManagement.Allergies.ReadAll',
      id: '7d46fca5-bd62-43c7-b053-57da68c7ace5'
    },
    {
      englishName: 'PatientManagement.LabAnalyses.ReadAll',
      id: '6056fc19-8812-4701-92d7-b424da47db82'
    },
    {
      englishName: 'SupplierManagement.LabAnalysisCenters.ReadAll',
      id: '107e4459-fce2-4368-a23f-de551285d68c'
    },
    {
      englishName: 'SupplierManagement.LabAnalysisCenters.Activate',
      id: 'f522684f-8981-43ba-975d-9695ebbce5ee'
    },
    {
      englishName: 'PatientManagement.Addictions.AddictionCategories.Update',
      id: '02112746-8242-4252-b056-4c2d0697ad6e'
    },
    {
      englishName: 'PatientManagement.XRays.Create',
      id: '5195d4e6-a040-425c-b970-ae64c75bf13b'
    },
    {
      englishName: 'PatientManagement.Surgeries.Update',
      id: '4bb02be1-b34b-4cdd-8370-627b9f4ad3cd'
    },
    {
      englishName: 'PatientManagement.XRays.Update',
      id: '4a5103c4-6e5e-4c22-bc4b-d3d377a02a5f'
    },
    {
      englishName: 'SupplierManagement.Hospitals.Read',
      id: 'eb368ee7-2dee-41a3-8cef-3995d9f577e7'
    },
    {
      englishName: 'UtilityManagement.Attachments.Read',
      id: '860699e1-5f45-4ca9-9674-32b742b29b38'
    },
    {
      englishName: 'SupplierManagement.Doctors.Activate',
      id: 'cec1b0fd-b8ca-4e33-8d14-9a3ec34dd80b'
    },
    {
      englishName: 'PharmacyManagement.Drugs.Activate',
      id: '6ca47d03-2bf9-4821-aed0-1858eb47bc8f'
    },
    {
      englishName: 'PatientManagement.Surgeries.Read',
      id: '843c8c89-4965-4778-b88d-b3ae698e308a'
    },
    {
      englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.ReadAll',
      id: 'bd6033b1-a99b-4263-b553-98c1872802b1'
    },
    {
      englishName: 'PatientManagement.Allergies.Import',
      id: '8694a366-5932-4fc7-9446-b2d9eaf429bd'
    },
    {
      englishName: 'PatientManagement.LabAnalyses.Activate',
      id: 'cb828ba5-1da1-4e75-83fe-26aa69e800e6'
    },
    {
      englishName: 'SupplierManagement.LabAnalysisCenters.DeActivate',
      id: 'dcdaed09-5a2e-4743-9e71-4a5d2dd2dfeb'
    },
    {
      englishName: 'SupplierManagement.XrayCenters.Create',
      id: '9617bac1-e20a-4619-b5f5-a3c10270d0fa'
    },
    {
      englishName: 'PatientManagement.LabAnalyses.Update',
      id: '458b5499-3ff3-4891-abd0-6b5c2de1f0fd'
    },
    {
      englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.DeActivate',
      id: '88c945a1-412d-47df-9762-6eea6dd66494'
    },
    {
      englishName: 'PatientManagement.XRays.Read',
      id: '77ff5753-3c54-4b8a-94e3-286d2ac9ebac'
    },
    {
      englishName: 'PharmacyManagement.Pharmacies.Create',
      id: 'c2fe5690-07b7-4ff9-b867-d372a4c3a025'
    },
    {
      englishName: 'PatientManagement.XRays.XRayCategories.DeActivate',
      id: '489da94a-d917-494c-8663-b3809fb971ee'
    },
    {
      englishName: 'PatientManagement.Addictions.AddictionCategories.Read',
      id: 'df441d01-d694-4012-be80-61e7b7b734b7'
    },
    {
      englishName: 'PatientManagement.Symptoms.Create',
      id: '9a3bad69-5a98-4a9a-b5d9-10f1adf4564a'
    },
    {
      englishName: 'PatientManagement.Symptoms.SymptomCategories.Create',
      id: 'cc5bd4e5-7bb4-4ae6-9672-0f5c560ab7db'
    },
    {
      englishName: 'PatientManagement.Diseases.Activate',
      id: '49557d1a-20c1-4f8e-a37e-84bc088161a0'
    },
    {
      englishName: 'UtilityManagement.Attachments.Create',
      id: '5521ed9b-cd88-46c8-97fe-9fb6c17e6a53'
    },
    {
      englishName: 'PatientManagement.Addictions.Update',
      id: '02e56ebf-1fe6-4561-86a9-4e338c9b10b5'
    },
    {
      englishName: 'PatientManagement.LabAnalyses.Create',
      id: 'cd022a9b-ec17-40a6-8f10-49c0a1b45f9a'
    },
    {
      englishName: 'PatientManagement.Symptoms.DeActivate',
      id: 'b62235bb-24b0-4f25-adc3-f29cfe7fbb08'
    },
    {
      englishName: 'PatientManagement.Surgeries.Create',
      id: '4a192605-0372-4d15-81c0-16b98118fc70'
    },
    {
      englishName: 'PatientManagement.Diseases.DiseaseCategories.Create',
      id: '882ef2af-56f1-4c0f-b52e-cfbfa2139a4b'
    },
    {
      englishName: 'PatientManagement.LabAnalyses.DeActivate',
      id: '1f35334d-d760-4116-a193-fcf2b4dbc806'
    },
    {
      englishName: 'SupplierManagement.Doctors.Update',
      id: 'a4285f66-93a2-459a-9ed2-6fb359d4da53'
    },
    {
      englishName: 'PatientManagement.Symptoms.SymptomCategories.Read',
      id: 'c4222ad7-8d31-4c6a-ab30-849263a93a1e'
    },
    {
      englishName: 'PatientManagement.Allergies.AllergyCategories.ReadAll',
      id: '18ff90f3-79dc-4657-80f6-5d01a339d44e'
    },
    {
      englishName: 'PatientManagement.Addictions.AddictionCategories.DeActivate',
      id: '1abbd14f-64eb-45f3-8ec7-6f84cf9eeb3e'
    },
    {
      englishName: 'SupplierManagement.Doctors.Create',
      id: '43113c9f-0af7-405b-bdc2-d44bf4282b32'
    },
    {
      englishName: 'PatientManagement.XRays.XRayCategories.ReadAll',
      id: '2b002274-82a0-4657-994a-9ec3fa50413c'
    },
    {
      englishName: 'PatientManagement.Surgeries.SurgeryCategories.Create',
      id: 'a23593d5-79db-440e-a86c-691da112bcc9'
    },
    {
      englishName: 'PatientManagement.Surgeries.SurgeryCategories.ReadAll',
      id: 'c2c39be1-db3b-4970-9f3f-ab8bdeabebf1'
    },
    {
      englishName: 'SupplierManagement.Doctors.ReadAll',
      id: '0101e959-49a0-4b49-8daa-033a8f8bc9db'
    },
    {
      englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Read',
      id: '84f5f633-f3a9-458a-9d4a-07c9853596e4'
    },
    {
      englishName: 'PatientManagement.Addictions.DeActivate',
      id: 'cd131856-990d-4781-9890-1e8f00011401'
    },
    {
      englishName: 'PatientManagement.Allergies.Activate',
      id: '4b80ea4d-4f9a-4c8b-b8b8-6eb593f8a86a'
    },
    {
      englishName: 'SupplierManagement.Hospitals.DeActivate',
      id: '065b634a-3a0b-45f5-a9e3-da8d037ff7d2'
    },
    {
      englishName: 'PatientManagement.Allergies.Read',
      id: '4c1ff8dc-f9b5-4fcb-b474-a9888b14ae17'
    },
    {
      englishName: 'PatientManagement.Symptoms.SymptomCategories.Activate',
      id: '76448b32-2fcc-424b-a8a2-4220a5e3612a'
    },
    {
      englishName: 'PatientManagement.Addictions.Read',
      id: '829f8641-a22c-4536-96b7-db3c19dd6278'
    },
    {
      englishName: 'PatientManagement.Symptoms.SymptomCategories.DeActivate',
      id: 'a4ee2495-1206-4784-8946-333eaa46c020'
    },
    {
      englishName: 'PatientManagement.Diseases.Import',
      id: 'd2cada41-308b-4c2c-aaba-a0f169162a7e'
    },
    {
      englishName: 'PatientManagement.Allergies.AllergyCategories.Activate',
      id: '42629b79-5f7b-4b0d-88cc-2e7324adb3d3'
    },
    {
      englishName: 'PatientManagement.XRays.XRayCategories.Update',
      id: 'a2bf836c-e664-4286-b5cb-809b17417f7a'
    },
    {
      englishName: 'PatientManagement.Allergies.AllergyCategories.Create',
      id: 'e91bfdc6-0dad-4776-939e-ae5d3e675428'
    },
    {
      englishName: 'SupplierManagement.Doctors.Read',
      id: '49a0a23f-c48c-40fa-b21b-980ddce5f25e'
    },
    {
      englishName: 'SupplierManagement.XrayCenters.Update',
      id: 'bd7b6303-d3f4-4808-af85-0ec7485186ee'
    },
    {
      englishName: 'SupplierManagement.Hospitals.Update',
      id: '2a98fa05-1437-4583-9376-6039be81022b'
    },
    {
      englishName: 'SupplierManagement.XrayCenters.DeActivate',
      id: '2c14dec0-4e0d-481d-8f29-e3069ffd1b6f'
    },
    {
      englishName: 'PatientManagement.XRays.Activate',
      id: 'cf78f878-42ee-4222-a804-a3d506c47c3b'
    },
    {
      englishName: 'PatientManagement.Diseases.Update',
      id: '49a6938b-7b54-4a45-9921-31238f564784'
    },
    {
      englishName: 'PharmacyManagement.Drugs.Create',
      id: '872fa262-897b-49bd-b63d-1058aaa0deae'
    },
    {
      englishName: 'PatientManagement.Symptoms.RemoveDrug',
      id: 'e5c19435-9208-4c97-8dce-d06f7416ce2d'
    },
    {
      englishName: 'PharmacyManagement.Pharmacies.DeActivate',
      id: 'e2fddbab-7f6f-4eac-95c6-ed32b2c7fa75'
    },
    {
      englishName: 'PatientManagement.Addictions.AddictionCategories.ReadAll',
      id: '6cee56f8-3795-4981-ba6e-e8b6d7500c52'
    },
    {
      englishName: 'PatientManagement.LabAnalyses.Import',
      id: '2a5c1fe7-3eed-408d-ad5b-35a0c3d1cff0'
    },
    {
      englishName: 'PatientManagement.Surgeries.SurgeryCategories.DeActivate',
      id: '7862ef61-7511-4234-adc3-4d2ac9806f78'
    },
    {
      englishName: 'SupplierManagement.Hospitals.Create',
      id: '23b7142a-4130-490f-a81a-82c594bb38bf'
    },
    {
      englishName: 'SupplierManagement.XrayCenters.Read',
      id: 'e80e5b94-e43b-4a63-963c-62cd12bfe79e'
    },
    {
      englishName: 'PharmacyManagement.Drugs.DeActivate',
      id: '552ad475-e6ee-4ead-b915-57fa053b94e4'
    },
    {
      englishName: 'PatientManagement.Allergies.AllergyCategories.DeActivate',
      id: '37e7ea4c-bca9-4794-8587-1877737ad7e4'
    },
    {
      englishName: 'PatientManagement.Symptoms.Update',
      id: '195ecccd-75ba-40d7-93b6-0e9d6a0b245a'
    },
    {
      englishName: 'PatientManagement.Allergies.Create',
      id: 'c884909c-3af1-478b-9169-f8d96c56b3d4'
    },
    {
      englishName: 'PatientManagement.Diseases.DeActivate',
      id: 'f9d4bbfa-7861-4ef5-b1e1-f226b23a0853'
    },
    {
      englishName: 'PatientManagement.Diseases.ReadAll',
      id: '5d573f0e-dea3-4061-9097-ad48e068d934'
    },
    {
      englishName: 'SupplierManagement.Hospitals.ReadAll',
      id: '58d9bde5-8698-4dea-901b-532546f42744'
    },
    {
      englishName: 'PatientManagement.Allergies.DeActivate',
      id: 'b2e9dfbb-14c6-4f50-bd31-8e130fb3c5b8'
    },
    {
      englishName: 'PharmacyManagement.Drugs.Read',
      id: 'd56cb521-e375-4197-938c-63525fbb4ee8'
    },
    {
      englishName: 'PatientManagement.Surgeries.Activate',
      id: '7abf2440-7b44-41e4-be80-d2c34cba8998'
    },
    {
      englishName: 'PatientManagement.Surgeries.SurgeryCategories.Update',
      id: 'ce343f81-a71e-4f34-a322-882118953b65'
    },
    {
      englishName: 'PatientManagement.XRays.XRayCategories.Create',
      id: '8d12c9ce-5fd1-4c5d-a7a1-84ee4b98a5e8'
    },
    {
      englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Activate',
      id: '051dd63d-0558-4dc8-a4a3-cb7933d77308'
    },
    {
      englishName: 'PatientManagement.Allergies.AllergyCategories.Read',
      id: '1f70f714-ded1-4735-908f-48af02bd5597'
    },
    {
      englishName: 'SupplierManagement.LabAnalysisCenters.Update',
      id: 'bd80a19a-950d-4b26-bbc6-af29ae669d30'
    },
    {
      englishName: 'PatientManagement.XRays.XRayCategories.Activate',
      id: 'fe59feb3-3546-490a-b778-5d2c02048555'
    },
    {
      englishName: 'PatientManagement.Surgeries.DeActivate',
      id: '317288c1-ff30-44fe-873e-421dd8d4ed5a'
    },
    {
      englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Update',
      id: '1e53e55b-05a0-43bc-8e09-4ca52df64763'
    },
    {
      englishName: 'PatientManagement.Diseases.Read',
      id: '8d226404-09f4-4932-9b0b-32bf2608af56'
    },
    {
      englishName: 'PatientManagement.Addictions.ReadAll',
      id: '8a1d5947-eb2d-47bb-8f95-5a9bc0d2f3dc'
    },
    {
      englishName: 'PharmacyManagement.Pharmacies.ReadAll',
      id: '4daecd21-ed04-4efe-9556-f90d3a7e7820'
    },
    {
      englishName: 'PatientManagement.Symptoms.Import',
      id: '829fd243-1c03-4572-9054-e630536828b2'
    },
    {
      englishName: 'PatientManagement.Symptoms.Read',
      id: '7d964f92-52a4-4bd7-be6d-2baa1cea9499'
    },
    {
      englishName: 'PatientManagement.XRays.Import',
      id: '94e68339-efe0-42b7-b1ff-cc80940ae768'
    },
    {
      englishName: 'PatientManagement.Symptoms.SymptomCategories.Update',
      id: '44ffd15b-bfdc-4656-87c0-bfd6cdd258a7'
    },
    {
      englishName: 'PatientManagement.LabAnalyses.Read',
      id: 'e6699e20-74fa-4244-bb72-4cdcd8592bba'
    },
    {
      englishName: 'PatientManagement.Allergies.Update',
      id: '8df13b5f-ea82-4c32-8c0b-91435abcb313'
    },
    {
      englishName: 'PatientManagement.Symptoms.Activate',
      id: 'b703a56f-0d20-402d-b2c7-3481a215d54c'
    },
    {
      englishName: 'PatientManagement.Diseases.DiseaseCategories.Read',
      id: '25d09104-34ce-441c-a63e-e41fe35ab609'
    },
    {
      englishName: 'PatientManagement.Diseases.DiseaseCategories.DeActivate',
      id: 'f374750f-a205-45ce-a06b-55dbd9303f5f'
    },
    {
      englishName: 'PatientManagement.Surgeries.SurgeryCategories.Read',
      id: 'ef4c4801-98ab-4e6b-a89e-9d5cc7c7428b'
    },
    {
      englishName: 'PatientManagement.Symptoms.SymptomCategories.ReadAll',
      id: '4ac1190e-c666-45a3-a3fc-c9f9ac4d5582'
    },
    {
      englishName: 'PatientManagement.Addictions.Create',
      id: '3b824c64-6a01-4902-b136-bf57842cce4f'
    },
    {
      englishName: 'PatientManagement.XRays.XRayCategories.Read',
      id: '29cb9146-e14f-4b22-a029-bd6039a667a4'
    },
    {
      englishName: 'PatientManagement.Addictions.AddictionCategories.Activate',
      id: '7125f732-ffa4-4132-9814-8bed0eeac110'
    },
    {
      englishName: 'PatientManagement.Addictions.Activate',
      id: '7ddd631a-4e81-4e65-818e-b9c19f5746fe'
    }
  ],
  englishName: 'Data Entry',
  id: '67298d2f-eb76-40de-884f-07aabacbd155'
};

const specialziedRoleCreateResponse: ISpecializedRoleCreateResponse = {
  name: 'Service Worker',
  createdOnUtc: '2025-05-07T10:25:33.5021949Z',
  modifiedOnUtc: '2025-05-07T10:25:33.5026098Z',
  createdById: '45021940-3f0b-4bbe-ae31-15f7da597ba1',
  modifiedById: '45021940-3f0b-4bbe-ae31-15f7da597ba1',
  id: '5230adb6-74d2-4788-8168-01e6f25d573f'
};

export const specizliedRolesData = {
  specilziedRoles,
  specialziedRole,
  specialziedRoleCreateResponse
};
